//商品設定～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～

  //* =====イニシャルペットボトルホルダー用一括設定 ===== */
    const buildInitialImages = (styleLabel, filePrefix) => {
    const map = {};
    const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    for (const ch of letters) {
      map[`${styleLabel}|${ch}`] = `${filePrefix}-${ch.toLowerCase()}.png`;
    }
    map[`${styleLabel}|イニシャルなし`] = "preview_without_design.png";
    return map;
    };

    // ==== hot-holder 用 5スタイルをまとめて生成 ====
    const initialPetHolderImages = Object.assign(
      {},
      buildInitialImages("1.フラワー",      "flower"),
      buildInitialImages("2.ブロック",      "block"),
      buildInitialImages("3.エレガント",    "elegant"),
      buildInitialImages("4.ステンシル",    "stencil"),
      buildInitialImages("5.ブラックレター","blackletter") 
    );


    window.engravingProductConfigs = {

  

//===メモリアル==================================================================================================================

  //乳歯ケース星座 FONT OK（商用可埋め込み可フリーフォント） 
    "tee-zd": {
    baseImage: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/tee-zd_base_preview2.png",
    designImageBaseUrl: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files",
    designComboLayers: [
    {
    id: "layer-main",
    combination: {
    keys: ["デザインを選択"],
    images: {
    "おひつじ座(3/21〜4/19)": "tee-zd_ohitsuji-za_preview.png",
    "おうし座(4/20〜5/20)": "tee-zd_oushi-za_preview.png",
    "ふたご座(5/21〜6/21)": "tee-zd_hutago-za_preview.png",
    "かに座(6/22〜7/22)": "tee-zd_kani-za_preview.png",
    "しし座(7/23〜8/22)": "tee-zd_shishi-za_preview.png",
    "おとめ座(8/23〜9/22)": "tee-zd_otome-za_preview.png",
    "てんびん座(9/23〜10/23)": "tee-zd_tenbin-za_preview.png",
    "さそり座(10/24〜11/21)": "tee-zd_sasori-za_preview.png",
    "いて座(11/22〜12/21)": "tee-zd_ite-za_preview.png",
    "やぎ座(12/22〜1/19)": "tee-zd_yagi-za_preview.png",
    "みずがめ座(1/20〜2/18)": "tee-zd_mizugame-za_preview.png",
    "うお座(2/19〜3/20)": "tee-zd_uo-za_preview.png"
    }}
    }
    ],  
    font: {
    name: "uzura",//許諾OK 
    url: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/uzura.woff2",
    textColor: "#333399"
    },
    textFields: [
    {
    inputId: "text-1",
    leftPercent: "50%", 
    align: "center",
    maxWidth: 470,
    bottomPercent: "19%",
    fontSize: "68px"
    }
    ]

    },

  //乳歯ケース干支 FONT OK（商用可埋め込み可フリーフォント） 
    "tee-eto": {				
    baseImage: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/tee-zd_base_preview2.png",				
    designImageBaseUrl: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files",				
    designComboLayers: [
    {
    id: "layer-main",
    combination: {
    keys: ["デザインを選択"],
    images: {			
    "ねずみ": "tee-eto_ne_preview.png",
    "うし": "tee-eto_ushi_preview.png",
    "とら": "tee-eto_tora_preview.png",
    "うさぎ": "tee-eto_u_preview.png",
    "たつ": "tee-eto_tatsu_preview.png",
    "へび": "tee-eto_mi_preview.png",
    "うま": "tee-eto_uma_preview.png",
    "ひつじ": "tee-eto_hitsuji_preview.png",
    "さる": "tee-eto_saru_preview.png",
    "とり": "tee-eto_tori_preview.png",
    "いぬ": "tee-eto_inu_preview.png",
    "いのしし": "tee-eto_i_preview.png",
    }}
    }
    ],  		
    font: {				
    name: "uzura",		//許諾OK 		
    url: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/uzura.woff2",				
    textColor: "#825b32"				
    },				
    textFields: [				
    {				
    inputId: "text-1",
    leftPercent: "50%", 
    align: "center",
    bottomPercent: "19%",
    maxWidth: 470,
    fontSize: "68px"				
    }				
    ]				
              
    },				

  //親子であそべるフォトスタンド どうぶつのおうち FONT OK（Adobe Font）
    "animal-photo": {
    baseImage: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/animal-photo-baby_base.png",
    designImageBaseUrl: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files",
    designComboLayers: [
    {
    id: "layer-main",
    combination: {
    keys: ["select-1"],
    images: {

    "1.THANK YOU": "animal-photo-baby-tnk.png",
    "2.HAPPY BIRTHDAY": "animal-photo-baby-hpb.png",
    "3.HAPPY ANNIVERSARY": "animal-photo-baby-han.png",
    "4.HAPPY MEMORIES": "animal-photo-baby-hmm.png"
    }
    }
    }
    ],	


    font: {
    name: "news-gothic-std",
    fontWeight: 700,
    textColor: "#5f3013"
    },
    textFields: [
    {
    inputId: "text-1",
    leftPercent: "49.94%",
    bottomPercent : "81.61%",
    fontSize: "51px",
    letterSpacing: "0em",
    align: "center",
    centerY: true,
    writingMode: "horizontal-tb",
    maxWidth: 261
    }
    ]
    },    

  //親子であそべるフォトスタンド どうぶつのおうち　ベイビーFONT OK（Adobe Font）
    "animal-photo-baby": {
    baseImage: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/animal-photo-baby_base.png",
    designImageBaseUrl: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files",
    designComboLayers: [
    {
    id: "layer-main",
    combination: {
    keys: [],
    images: {     
    "": "preview_without_design.png"
    }}
    }
    ],

    allowedChars: "^[A-Za-z0-9.\\-:, ]+$",

    font: {
    name: "news-gothic-std",
    fontWeight: 700,
    textColor: "#5f3013"
    },
    textFields: [
    {
    inputId: "text-1",
    leftPercent: "49.94%",
    bottomPercent : "81.61%",
    fontSize: "51px",
    letterSpacing: "0em",
    align: "center",
    centerY: true,
    writingMode: "horizontal-tb",
    maxWidth: 261
    },
    {
   inputId: "text-2",
    leftPercent: "50.07%",
    bottomPercent : "61.36%",
    fontSize: "46.55px",
    letterSpacing: "0em",
    align: "center",
    maxWidth: 261,    
    centerY: true,
    
    writingMode: "horizontal-tb"
    },
    {
    inputId: "text-3",
    leftPercent: "50.07%",
    bottomPercent : "54.74%",
    fontSize: "46.55px",
    letterSpacing: "0em",
    align: "center",
    centerY: true,
    maxWidth: 261,
    writingMode: "horizontal-tb"
    },
    {
    inputId: "text-4",
    leftPercent: "50.07%",
    bottomPercent : "48.13%",
    fontSize: "46.55px",
    letterSpacing: "0em",
    align: "center",
    centerY: true,
    maxWidth: 261,
    writingMode: "horizontal-tb"
    },
    {
    inputId: "text-5",
    leftPercent: "50.07%",
    bottomPercent : "41.50%",
    fontSize: "46.55px",
    letterSpacing: "0em",
    align: "center",
    centerY: true,
    maxWidth: 261,
    writingMode: "horizontal-tb"
    }



    ]
    },  


//===コップ・タンブラー・食器======================================================================================================

  //麻の葉タンブラー うすづくり FONT OK（テキスト使用なし） 

    "asa-tan-usu": {	

    baseImage: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/asa-tan-usu_base.png",
    designImageBaseUrl: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files",
    designComboLayers: [
      {
        id: "static-design",
        
        combination: {
        keys: ["select-1"],                   
        images: {
        "ありがとう": "asa-tan-usu_argt.png",
        "いつもありがとう": "asa-tan-usu_ituari.png",
        "感謝": "asa-tan-usu_knsya.png",
        "おめでとう": "asa-tan-usu_omdt.png",
        "心から感謝を込めて": "asa-tan-usu_kokoro.png",
        "いつまでも元気でいてください": "asa-tan-usu_itugenki.png",
        "これからもよろしくお願いします": "asa-tan-usu_korekara.png",
        "御祝": "asa-tan-usu_onsyuku.png",
        "御礼": "asa-tan-usu_onrei.png",
        "内祝": "asa-tan-usu_uchi.png",
        "祝 御結婚": "asa-tan-usu_sykekkon.png",
        "結婚おめでとう": "asa-tan-usu_kekkonome.png",
        "お誕生日おめでとう": "asa-tan-usu_otaome.png",
        "寿": "asa-tan-usu_ktbk.png",
        "長寿": "asa-tan-usu_choju.png",
        "長生きしてね": "asa-tan-usu_ngiki.png",
        "祝 還暦": "asa-tan-usu_knrk.png",
        "祝 古希": "asa-tan-usu_koki.png",
        "祝 喜寿": "asa-tan-usu_kiju.png",
        "祝 傘寿": "asa-tan-usu_sanju.png",
        "祝 米寿": "asa-tan-usu_beiju.png",
        "祝 卒寿": "asa-tan-usu_sotuju.png",
        "祝 白寿": "asa-tan-usu_hakuju.png",
        "祝 百寿": "asa-tan-usu_momoju.png",
        "お父さんいつもありがとう": "asa-tan-usu_otoari.png",
        "Happy Father’s Day": "asa-tan-usu_hapiba.png",
        "Thank You Father": "asa-tan-usu_tnksfa.png",
        "お母さんいつもありがとう": "asa-tan-usu_okaari.png",
        "Happy Mother’s Day": "asa-tan-usu_hpmt.png",
        "Thank You Mother": "asa-tan-usu_tnksma.png",
        "おつかれさまでした": "asa-tan-usu_otsu.png",
        "ありがとうございました": "asa-tan-usu_argtg.png",
        "おめでとうございます": "asa-tan-usu_omdtg.png",
        "祝 ご勇退": "asa-tan-usu_yutai.png",
        "祝 ご栄転": "asa-tan-usu_eiten.png",
        "祝 ご退職": "asa-tan-usu_taisyoku.png",
        "祝 金婚": "asa-tan-usu_kin.png",
        "祝 銀婚": "asa-tan-usu_gin.png"
          
        }
      }
    }
    ],
    font: {
    name: "DHPGyoSho-Lt", //ダイナコム
    url: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/DHPGyoSho-Lt.woff2",
    textColor: "#352201"
    },
        textFields: [				
    {				
    inputId: "text-1",//名前
    leftPercent: "42.5%",
    align: "center",
    bottomPercent: "27.5%",
    centerY: true,
    letterSpacing: "-0.02em",
    fontSize: "59px",
    maxWidth: 200,
    allowedChars: "^[A-Za-z0-9.\\- ]+$"
	
    }			
    ]
     
    }, 


  //ステンレス マグカップ ワンポイント デザイン  FONT OK（Adobe Font）
    "stmg-outd-op":{
    baseImage: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/stmg-outd_base.png",
    designImageBaseUrl: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files",
    designComboLayers: [
    {
    id: "layer-main",
    combination: {
    keys: ["デザインを選択"], // ← select の id をそのまま
    images: {
      "テント": "stmg-outd-op_tent.png",
      "焚火": "stmg-outd-op_hi.png",
      "森": "stmg-outd-op_mori.png",
      "山": "stmg-outd-op_yama.png",
      "太陽": "stmg-outd-op_sun.png",
      "ランタン": "stmg-outd-op_lump.png",
      "ナイフ": "stmg-outd-op_knife.png",
      "斧": "stmg-outd-op_ono.png",
      "リュック": "stmg-outd-op_ruck.png",
      "ブーツ": "stmg-outd-op_butsu.png",
      "キャンピングカー": "stmg-outd-op_kcar.png",
      "カメラ": "stmg-outd-op_kmr.png",
      "釣り": "stmg-outd-op_tsuri.png",
      "カヌー": "stmg-outd-op_kykk.png",
      "自転車": "stmg-outd-op_bycl.png",
      "髭": "stmg-outd-op_hige.png",
      "唇": "stmg-outd-op_kcbr.png",
      "ドクロ": "stmg-outd-op_dkr.png",
      "クマ": "stmg-outd-op_kuma.png",
      "ウサギ": "stmg-outd-op_usa.png",
      "ネコ": "stmg-outd-op_neko.png",
      "イヌ": "stmg-outd-op_inu.png",
      "シカ": "stmg-outd-op_shika.png",
      "サル": "stmg-outd-op_saru.png",
      "イノシシ": "stmg-outd-op_inss.png",
      "クローバー": "stmg-outd-op_crvr.png",
      "フラワー": "stmg-outd-op_hana.png",
      "どんぐり": "stmg-outd-op_dngr.png",
      "葉っぱ": "stmg-outd-op_happa.png",
      "きのこ": "stmg-outd-op_knk.png"
      }
      }
    }
    ],  


		
    font: {
    name: "swiss-721-bt-condensed",
    fontweight: 700,
    textColor: "#5c5c5c"			
    },	
    
    
    textFields: [				
    {				
    inputId: "text-1",//名前
    leftPercent: "42.5%",
    align: "center",
    bottomPercent: "27.5%",
    centerY: true,
    letterSpacing: "-0.02em",
    fontSize: "59px",
    maxWidth: 200,
    allowedChars: "^[A-Za-z0-9.\\- ]+$"
	
    }			
    ]
      
    },

  //oyajiタンブラー  FONT OK（商用可埋め込み可フリーフォント）
    "oyji-tblr":{
    baseImage: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/oyji-tbl_base.png",
        designComboLayers: [
    {
    id: "layer-main",
    combination: {
    keys: ["select-2"], // ← select の id をそのまま
    images: {
      "父": "oyji-tblr_titi_preview.png",
      "祝": "oyji-tblr_syuku_preview.png",
      "39": "oyji-tbl_39_preview.png",
      "カスタマイズ": "oyji-tblr_cus_preview.png"
    }}
    }
    ],  
    designImageBaseUrl: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files",


    font: {				
      name: "collegeb",				
      url: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/collegeb.woff2",				
      textColor: "#221714"			
    },	
    
    
    textFields: [				
    {				
    inputId: "text-1",//名前
    leftPercent: "50%",
    align: "center",
    bottomPercent: "31.5%",
    centerY: true,
    letterSpacing: "-0.02em",
    fontSize: "35px",
    maxWidth: 200,
    allowedChars: "^[A-Za-z0-9.\\- ]+$",
    font: { name: "college", url: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/college.woff2",textColor: "#221714" }				
    },
        {				
    inputId: "text-2",//カスタマイズ
    leftPercent: "50%",
    align: "center",
    bottomPercent: "40.5%",
    centerY: true,
    letterSpacing: "-0.02em",
    fontSize: "72px",
    allowedChars: "^[0-9]+$",
    font: { name: "collegeb", url: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/collegeb.woff2",textColor: "#221714" }				
    },	
        {				
    inputId: "text-3",//日付
    leftPercent: "50%",
    align: "center",
    bottomPercent: "35.3%",
    centerY: true,
    letterSpacing: "-0.02em",
    fontSize: "29px",
    allowedChars: "^[0-9.]+$",
    font: { name: "collegeb", url: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/collegeb.woff2",textColor: "#221714" }				
    }				
    ]
      
    },

  //oyajiステンレスマグ  FONT OK（商用可埋め込み可フリーフォント）
    "stmg-oyaji":{
    baseImage: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/stmg-oyaji_base.png",
        designComboLayers: [
    {
    id: "layer-main",
    combination: {
    keys: ["select-2"], // ← select の id をそのまま
    images: {
      "父": "stmg-oyaji_titi_preview.png",
      "祝": "stmg-oyaji_syuku_preview.png",
      "39": "stmg-oyaji_39_preview.png",
      "カスタマイズ": "stmg-oyaji_cus_preview.png"
    }}
    }
    ],  
    designImageBaseUrl: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files",


    font: {				
      name: "collegeb",			//許諾OK 無料フォント	
      url: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/collegeb.woff2",				
      textColor: "#221714"			
    },	
    
    
    textFields: [				
    {				
    inputId: "text-1",//名前
    leftPercent: "42%",
    align: "center",
    bottomPercent: "18.75%",
    centerY: true,
    letterSpacing: "-0.03em",
    fontSize: "40px",
    maxWidth: 240,
    allowedChars: "^[A-Za-z0-9.\\- ]+$",
    font: { name: "college", url: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/college.woff2",textColor: "#221714" }				
    },
        {				
    inputId: "text-4",//カスタマイズ
    leftPercent: "42%",
    align: "center",
    bottomPercent: "28.75%",
    centerY: true,
    letterSpacing: "-0.02em",
    fontSize: "84px",
    allowedChars: "^[0-9]+$",
    font: { name: "collegeb", url: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/collegeb.woff2",textColor: "#221714" }				
    },	
        {				
    inputId: "text-3",//日付
    leftPercent: "42%",
    align: "center",
    bottomPercent: "22.75%",
    centerY: true,
    letterSpacing: "-0.02em",
    fontSize: "33px",
    allowedChars: "^[0-9.]+$",
    font: { name: "collegeb", url: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/collegeb.woff2",textColor: "#221714" }				
    }				
    ]
      
    },

  //oyajiジョッキ  FONT OK（商用可埋め込み可フリーフォント）
    "thermos-oyaji":{
    baseImage: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/thermos-oyaji_base.png?v=1755658706",
        designComboLayers: [
    {
    id: "layer-main",
    combination: {
    keys: ["select-2"], // ← select の id をそのまま
    images: {
      "父": "thermos-oyaji_titi_preview.png",
      "祝": "thermos-oyaji_syuku_preview.png",
      "39": "thermos-oyaji_39_preview.png",
      "カスタマイズ": "thermos-oyaji_no_preview.png"
    }}
    }
    ],  
    designImageBaseUrl: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files",


    font: {				
      name: "collegeb",				//許諾OK 無料フォント
      url: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/collegeb.woff2",				
      textColor: "#4b493c"			
    },	
    
    
    textFields: [				
    {				
    inputId: "text-1",//名前
    leftPercent: "44%",
    align: "center",
    bottomPercent: "19.5%",
    centerY: true,
    letterSpacing: "-0.03em",
    fontSize: "41px",
    maxWidth: 240,
    allowedChars: "^[A-Za-z0-9.\\- ]+$",
    font: { name: "college", url: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/college.woff2",textColor: "#4b493c" }				
    },
        {				
    inputId: "text-4",//カスタマイズ
    leftPercent: "44%",
    align: "center",
    bottomPercent: "38.5%",
    centerY: true,
    letterSpacing: "-0.02em",
    fontSize: "86px",
    allowedChars: "^[0-9]+$",
    font: { name: "collegeb", url: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/collegeb.woff2",textColor: "#4b493c" }				
    },	
        {				
    inputId: "text-3",//日付
    leftPercent: "44%",
    align: "center",
    bottomPercent: "32.5%",
    centerY: true,
    letterSpacing: "-0.04em",
    fontSize: "33px",
    allowedChars: "^[0-9.]+$",
    font: { name: "collegeb", url: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/collegeb.woff2",textColor: "#4b493c" }				
    }				
    ]
      
    },    

  //二代目パパマグ＆ ソープフラワー ギフトセット   FONT OK（Adobe Font）
    "papamug-fset":{
    baseImageSelectorName: "カラーを選択",  
    baseImages: {				
    "ブラック": "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/papamug-2nd_blk_base.png?v=1755650753",
    "ホワイト": "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/papamug-2nd_whi_base.png?v=1755650753"		
    },
    designImageBaseUrl: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files",   
    designComboLayers: [
    {
    id: "layer-main",
    combination: {
    keys: ["select-5"],
    images: {
		
      "ひげメガネ": "papamug-2nd_hige_preview.png?v=1755650752",
      "いつもありがとう": "papamug-2nd_ari_preview.png?v=1755650752"

    }}
    }
    ],  				
    font: {
      name: "rockwell",
      fontweight: 400,
      textColor: "#9b9b9b"			
    },	
    
    
    textFields: [				
    {				
    inputId: "text-1",//名前
    leftPercent: "44%",
    align: "center",
    bottomPercent: "27%",
    centerY: true,
    letterSpacing: "0.05em",
    fontSize: "35px",
    maxWidth: 240,
    allowedChars: "^[A-Za-z0-9.\\- ]+$",

    }
    ]
    },

  //二代目パパマグ  FONT OK（Adobe Font）
    "papamug-2nd":{
    baseImageSelectorName: "カラーを選択",  
    baseImages: {				
    "ブラック": "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/papamug-2nd_blk_base.png?v=1755650753",
    "ホワイト": "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/papamug-2nd_whi_base.png?v=1755650753"		
    },

    designImageBaseUrl: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files",   
    designComboLayers: [
    {
    id: "layer-main",
    combination: {
    keys: ["select-2"],
    images: {
	      "ひげメガネ": "papamug-2nd_hige_preview.png?v=1755650752",
      "いつもありがとう": "papamug-2nd_ari_preview.png?v=1755650752"
    }}
    }
    ],  				
    font: {
      name: "rockwell",
      fontweight: 400,
      textColor: "#9b9b9b"			
    },	
    
    
    textFields: [				
    {				
    inputId: "text-1",//名前
    leftPercent: "44%",
    align: "center",
    bottomPercent: "27%",
    centerY: true,
    letterSpacing: "0.05em",
    fontSize: "35px",
    maxWidth: 240,
    allowedChars: "^[A-Za-z0-9.\\- ]+$",

    }
    ]
    },    

  //パパ髭Sinqsタンブラー   FONT OK（Adobe Font）
    "pphg-sqtbr":{
    baseImages: {				
    "ブラック": "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/pphg-sqtbr_blk_base.png?v=1755504740",
    "ホワイト": "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/pphg-sqtbr_wht_base.png?v=1755504740",				
    "モカ": "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/pphg-sqtbr_mca_base.png?v=1755504740"				
    },
    baseImageSelectorName: "カラーを選択",
    designImageBaseUrl: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files",				
    designComboLayers: [
    {
    id: "layer-main",
    combination: {
    keys: ["デザインを選択"],
    images: {				
      "メガネ": "pphg-sqtbr_mgn_preview.png?v=1755504739",
      "帽子": "pphg-sqtbr_hat_preview.png?v=1755504739",
      "蝶ネクタイ": "pphg-sqtbr_nkti_preview.png?v=1755504739"
    }}
    }
    ],  		
		
    font: {
      name: "sitka-text",
      fontweight: 400,
      textColor: "#9f9fa0"			
    },	
    
    
    textFields: [				
    {				
    inputId: "text-2",//名前
    leftPercent: "50%",
    align: "center",
    bottomPercent: "52%",
    centerY: true,
    letterSpacing: "-0.03em",
    fontSize: "52px",
    maxWidth: 200,
    allowedChars: "^[A-Za-z0-9.\\- ]+$",
    ConvertToCursiveFormat: true,
    font: { name: "Bestowens", url: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/Bestowens.woff2",textColor: "#9f9fa0" }				
    },
        {				
    inputId: "text-1",//日付
    leftPercent: "50%",
    align: "center",
    bottomPercent: "42%",
    centerY: true,
    letterSpacing: "0.05em",
    fontSize: "20.5px",
    maxWidth: 240,
    allowedChars: "^[0-9.\\- ]+$",
    font: { name: "sitka-text", fontweight: 400,textColor: "#9f9fa0" }				
    },
    {				
    inputId: "select-5",//メッセージ
    leftPercent: "50%",
    align: "center",
    bottomPercent: "45%",
    centerY: true,
    letterSpacing: "0.03em",
    fontSize: "20.5px",
    allowedChars: "^[A-Za-z0-9.\\- '’!?]+$",
    font: {  name: "sitka-text", fontweight: 400,textColor: "#9f9fa0" }				
    }				
    ]
      

    },    


//===水筒・ペットボトルホルダー====================================================================================================

  //STOSペットボトルホルダー  FONT OK（Adobe Font）
    "stos-pb-holder": {


    baseImageSelectorName: "カラーを選択",
    baseImages: {			
    "ベージュ": "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/stos-pb-holder-beg_base.png?v=1755499277",
    "ライトカーキ": "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/stos-pb-holder-lkh_base.png?v=1755499277",
    "パープル": "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/stos-pb-holder-ppl_base.png?v=1755499277",
    "グレージュ": "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/stos-pb-holder-grg_base.png?v=1755499277",
    "チャコールグレー": "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/stos-pb-holder-cgr_base.png?v=1755499277",
    "サックスブルー": "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/stos-pb-holder-sbl_base.png?v=1755499277"		
    },

    designImageBaseUrl: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files",
        designComboLayers: [
    {
    id: "layer-main",
    combination: {
    keys: ["select-1"], // ← select の id をそのまま
    images: {
      "-- 選択してください --": "preview_without_design.png",
      "あり": "stos-pb-holder_design.png",
      "なし": "preview_without_design.png"
    }}
    }
    ],  

    font: {
    name: "century-gothic",
    fontweight: 700,
    textColor: "#ffffff"
    },
    textFields: [
    {
      inputId: "text-1",
      leftPercent: "50%", 
      align: "center",
      centerY: true,
      bottomPercent : "12.5%",
      fontSize: "24px",
      allowedChars: /^[a-zA-Z0-9\s\-]+$/, 
      letterSpacing: "0.05em",
      maxWidth: 130
    }
    ]
    },

  //保温 ペットボトルホルダー　FONT OK（Adobe Font/商用可埋め込み可フリーフォント）
    "hot-holder": {
    baseImageSelectorName: "カラーを選択",
    baseImages: {			
    "ブラック": "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/hot-holder-blk-base.png",
    "アイボリー": "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/hot-holder-ivr-base.png"	
    },
    designImageBaseUrl: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files",
    designComboLayers: [{
    id: "layer-main",
    combination: {
    keys: ["select-1", "イニシャルを選択"],
    images:initialPetHolderImages
    }}],	


    font: {name: "arial",fontweight: 400,textColor: "#988f8e"},

    fontByGPO: {
    "select-1": {
      "1.フラワー": {name: "LiberationSerif-Regular",url: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/LiberationSerif-Regular.woff2"},//FONT OK（商用可埋め込み可フリーフォント）
      "2.ブロック": {name: "arial",fontweight: 400}, //FONT OK（Adobe Font）
      "3.エレガント": {name: "LiberationSerif-Regular",url: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/LiberationSerif-Regular.woff2"},//FONT OK（商用可埋め込み可フリーフォント）
      "4.ステンシル": {name: "boston",url: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/boston.woff2"},//FONT OK（商用可埋め込み可フリーフォント）
      "5.ブラックレター": {name: "GLECB",url: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/GLECB.woff2"} //FONT OK（商用可埋め込み可フリーフォント）
    }
    },

    textFields: [{
      inputId: "text-1",
      leftPercent: "50%", 
      align: "center",
      centerY: true,
      bottomPercent : "21.5%",
      fontSize: "26px",
      allowedChars: /^[a-zA-Z0-9\s\-]+$/, 
      letterSpacing: "0.05em",
      maxWidth: 130
    }]
    },

  //折りたたみハンドル式ペットボトルクーラー/ ABIB-E  FONT OK（Adobe Font/商用可埋め込み可フリーフォント）
      "h-pb-holder": {
    baseImageSelectorName: "カラーを選択",
    baseImages: {			
    "ブラック": "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/h-pb-holder_blk-base.png",
    "ホワイト": "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/h-pb-holder_whi-base.png",
    "ピンクベージュ": "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/h-pb-holder_pnk-base.png",
    "ベビーブルー": "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/h-pb-holder_blu-base.png",
    "グレー": "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/h-pb-holder_gry-base.png"	
    },
    designImageBaseUrl: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files",
    designComboLayers: [{
    id: "layer-main",
    combination: {
    keys: ["select-1", "イニシャルを選択"],
    images:initialPetHolderImages
    }}],	

    font: {name: "arial",fontweight: 400,textColor: "#988f8e"},

    fontByGPO: {
    "select-1": {
      "1.フラワー": {name: "LiberationSerif-Regular",url: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/LiberationSerif-Regular.woff2"},//FONT OK（商用可埋め込み可フリーフォント）
      "2.ブロック": {name: "arial",fontweight: 400}, //FONT OK（Adobe Font）
      "3.エレガント": {name: "LiberationSerif-Regular",url: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/LiberationSerif-Regular.woff2"},//FONT OK（商用可埋め込み可フリーフォント）
      "4.ステンシル": {name: "boston",url: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/boston.woff2"},//FONT OK（商用可埋め込み可フリーフォント）
      "5.ブラックレター": {name: "GLECB",url: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/GLECB.woff2"} //FONT OK（商用可埋め込み可フリーフォント）
    }
    },

    textFields: [{
      inputId: "text-1",
      leftPercent: "50%", 
      align: "center",
      centerY: true,
      bottomPercent : "21.5%",
      fontSize: "26px",
      allowedChars: /^[a-zA-Z0-9\s\-]+$/, 
      letterSpacing: "0.05em",
      maxWidth: 130
    }]
    },
  //Be-Side ペットボトルクーラー FONT OK（Adobe Font/商用可埋め込み可フリーフォント）
        "be-pb-cooler": {
    baseImageSelectorName: "カラーを選択",
    baseImages: {			
    "ホワイト": "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/be-pb-cooler-whi-base.png?v=1756367859",
    "カーキ": "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/be-pb-cooler-khk-base.png?v=1756367865",
    "ブルー": "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/be-pb-cooler-blu-base.png?v=1756367874",
    "オレンジ": "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/be-pb-cooler-org-base.png?v=1756367870"	
    },
    designImageBaseUrl: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files",
    designComboLayers: [{
    id: "layer-main",
    combination: {
    keys: ["select-1", "buttons-1"],
    images:initialPetHolderImages
    }}],	

    font: {name: "arial",fontweight: 400,textColor: "#988f8e"},

    fontByGPO: {
    "select-1": {
      "1.フラワー": {name: "LiberationSerif-Regular",url: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/LiberationSerif-Regular.woff2"},//FONT OK（商用可埋め込み可フリーフォント）
      "2.ブロック": {name: "arial",fontweight: 400}, //FONT OK（Adobe Font）
      "3.エレガント": {name: "LiberationSerif-Regular",url: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/LiberationSerif-Regular.woff2"},//FONT OK（商用可埋め込み可フリーフォント）
      "4.ステンシル": {name: "boston",url: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/boston.woff2"},//FONT OK（商用可埋め込み可フリーフォント）
      "5.ブラックレター": {name: "GLECB",url: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/GLECB.woff2"} //FONT OK（商用可埋め込み可フリーフォント）
    }
    },

    textFields: [{
      inputId: "text-1",
      leftPercent: "50%", 
      align: "center",
      centerY: true,
      bottomPercent : "21.5%",
      fontSize: "26px",
      allowedChars: /^[a-zA-Z0-9\s\-]+$/, 
      letterSpacing: "0.05em",
      maxWidth: 130
    }]
    },

  //Be-Side ペットボトルクーラー&ローズブーケ FONT OK（Adobe Font/商用可埋め込み可フリーフォント）
        "be-pb-cooler-br": {
    baseImageSelectorName: "カラーを選択（ボトルクーラー）",
    baseImages: {			
    "ホワイト": "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/be-pb-cooler-whi-base.png?v=1756367859",
    "カーキ": "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/be-pb-cooler-khk-base.png?v=1756367865",
    "ブルー": "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/be-pb-cooler-blu-base.png?v=1756367874",
    "オレンジ": "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/be-pb-cooler-org-base.png?v=1756367870"	
    },
    designImageBaseUrl: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files",
    designComboLayers: [{
    id: "layer-main",
    combination: {
    keys: ["select-1", "イニシャルを選択"],
    images:initialPetHolderImages
    }}],	

    font: {name: "arial",fontweight: 400,textColor: "#988f8e"},

    fontByGPO: {
    "select-1": {
      "1.フラワー": {name: "LiberationSerif-Regular",url: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/LiberationSerif-Regular.woff2"},//FONT OK（商用可埋め込み可フリーフォント）
      "2.ブロック": {name: "arial",fontweight: 400}, //FONT OK（Adobe Font）
      "3.エレガント": {name: "LiberationSerif-Regular",url: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/LiberationSerif-Regular.woff2"},//FONT OK（商用可埋め込み可フリーフォント）
      "4.ステンシル": {name: "boston",url: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/boston.woff2"},//FONT OK（商用可埋め込み可フリーフォント）
      "5.ブラックレター": {name: "GLECB",url: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/GLECB.woff2"} //FONT OK（商用可埋め込み可フリーフォント）
    }
    },

    textFields: [{
      inputId: "text-1",
      leftPercent: "50%", 
      align: "center",
      centerY: true,
      bottomPercent : "21.5%",
      fontSize: "26px",
      allowedChars: /^[a-zA-Z0-9\s\-]+$/, 
      letterSpacing: "0.05em",
      maxWidth: 130
    }]
    },
  //ステンレス ペットボトルホルダー/ABIB-C FONT OK（Adobe Font/商用可埋め込み可フリーフォント）
        "s_b_holder": {
    baseImageSelectorName: "カラーを選択",
    baseImages: {			
    "ブラック": "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/s_b_holder-blk-base.png",
    "ホワイト": "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/s_b_holder-whi-base.png",
    "シルバー": "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/s_b_holder-slv-base.png",
    "パープル": "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/s_b_holder-ppl-base.png",
    "アイスグリーン": "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/s_b_holder-grn-base.png"	
    },
    designImageBaseUrl: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files",
    designComboLayers: [{
    id: "layer-main",
    combination: {
    keys: ["select-1", "イニシャルを選択"],
    images:initialPetHolderImages
    }}],	

    font: {name: "arial",fontweight: 400,textColor: "#988f8e"},

    fontByGPO: {
    "select-1": {
      "1.フラワー": {name: "LiberationSerif-Regular",url: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/LiberationSerif-Regular.woff2"},//FONT OK（商用可埋め込み可フリーフォント）
      "2.ブロック": {name: "arial",fontweight: 400}, //FONT OK（Adobe Font）
      "3.エレガント": {name: "LiberationSerif-Regular",url: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/LiberationSerif-Regular.woff2"},//FONT OK（商用可埋め込み可フリーフォント）
      "4.ステンシル": {name: "boston",url: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/boston.woff2"},//FONT OK（商用可埋め込み可フリーフォント）
      "5.ブラックレター": {name: "GLECB",url: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/GLECB.woff2"} //FONT OK（商用可埋め込み可フリーフォント）
    }
    },

    textFields: [{
      inputId: "text-1",
      leftPercent: "50%", 
      align: "center",
      centerY: true,
      bottomPercent : "21.5%",
      fontSize: "26px",
      allowedChars: /^[a-zA-Z0-9\s\-]+$/, 
      letterSpacing: "0.05em",
      maxWidth: 130
    }]
    },
  //ボトルインボトル ストラップ/ABIB-B FONT OK（Adobe Font/商用可埋め込み可フリーフォント）
        "sb-strap": {
    baseImageSelectorName: "カラーを選択",
    baseImages: {			
    "ブラック": "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/sb-strap-blk-base.png",
    "ホワイト": "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/sb-strap-whi-base.png"
    },
    designImageBaseUrl: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files",
    designComboLayers: [{
    id: "layer-main",
    combination: {
    keys: ["select-1", "イニシャルを選択"],
    images:initialPetHolderImages
    }}],	

    font: {name: "arial",fontweight: 400,textColor: "#988f8e"},

    fontByGPO: {
    "select-1": {
      "1.フラワー": {name: "LiberationSerif-Regular",url: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/LiberationSerif-Regular.woff2"},//FONT OK（商用可埋め込み可フリーフォント）
      "2.ブロック": {name: "arial",fontweight: 400}, //FONT OK（Adobe Font）
      "3.エレガント": {name: "LiberationSerif-Regular",url: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/LiberationSerif-Regular.woff2"},//FONT OK（商用可埋め込み可フリーフォント）
      "4.ステンシル": {name: "boston",url: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/boston.woff2"},//FONT OK（商用可埋め込み可フリーフォント）
      "5.ブラックレター": {name: "GLECB",url: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/GLECB.woff2"} //FONT OK（商用可埋め込み可フリーフォント）
    }
    },

    textFields: [{
      inputId: "text-1",
      leftPercent: "50%", 
      align: "center",
      centerY: true,
      bottomPercent : "21.5%",
      fontSize: "26px",
      allowedChars: /^[a-zA-Z0-9\s\-]+$/, 
      letterSpacing: "0.05em",
      maxWidth: 130
    }]
    },
//===雑貨=======================================================================================================================

  //SAKURAハーバリウム ドロップ   FONT OK（Adobe Font）

    "sakura-harba-drop": {	

    baseImage: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/sakura-harba-drop_base.png",
    designImageBaseUrl: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files",
    designComboLayers: [
      {
        id: "static-design",
        zIndex: 10,
       
        keys: [],                   
        images: {"": "preview_without_design.png"}
      }
    ],

    font: {
    name: "arno-pro",
    fontweight: 400,
    textColor: "#563b2c"
    },
   
    textFields: [				
    {				
    inputId: "text-1",//名前
    leftPercent: "50%",
    align: "center",
    bottomPercent: "89%",
    centerY: true,
    letterSpacing: "0em",
    fontSize: "36px",
    maxWidth: 140,
    allowedChars: "^[A-Za-z0-9.\\- ]+$"		
    },
        {				
    inputId: "text-2",//日付
    leftPercent: "50%",
    align: "center",
    bottomPercent: "83.5%",
    centerY: true,
    letterSpacing: "0em",
    fontSize: "18px",
    allowedChars: "^[A-Za-z0-9.\\- ]+$"				
    },
    {
        inputId: "select-2",//メッセージ
    leftPercent: "50%",
    align: "center",
    bottomPercent: "86%",
    centerY: true,
    letterSpacing: "0em",
    fontSize: "16.5px",
    allowedChars: "^[A-Za-z0-9.\\-!’' ]+$"				
    }
	
    ]


      
    },    

  //カーネーションハーバリウム  FONT OK（Adobe Font）
    "cnt-hbr": {	

    baseImageSelectorName: "カラーを選択",
    baseImages: {			
    "レッド": "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/cnt-hbr-re.png",
    "パープル": "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/cnt-hbr-pl.png",
    "ピンク": "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/cnt-hbr-pk.png",
    "イエロー": "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/cnt-hbr-ye.png"		
    },
    designImageBaseUrl: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files",
    designComboLayers: [
      {
        id: "static-design",
        zIndex: 10,
       
        keys: [],                   
        images: {"": "preview_without_design.png"}
      }
    ],
    font: {
    name: "arno-pro",
    fontweight: 400,
    textColor: "#563b2c"
    },

   
    textFields: [				
    {				
    inputId: "text-1",//名前
    leftPercent: "50%",
    align: "center",
    bottomPercent: "87%",
    centerY: true,
    letterSpacing: "0em",
    fontSize: "40px",
    maxWidth: 140,
    allowedChars: "^[A-Za-z0-9.\\- ]+$"		
    },
        {				
    inputId: "text-2",//日付
    leftPercent: "50%",
    align: "center",
    bottomPercent: "80%",
    centerY: true,
    letterSpacing: "0em",
    fontSize: "20.5px",
    allowedChars: "^[A-Za-z0-9.\\- ]+$"				
    },
    {
        inputId: "select-1",//メッセージ
    leftPercent: "50%",
    align: "center",
    bottomPercent: "83%",
    centerY: true,
    letterSpacing: "0em",
    fontSize: "18.7px",
    allowedChars: "^[A-Za-z0-9.\\-!’' ]+$"				
    }
	
    ]


      
    },
  //ハーバリウム ドロップ FONT OK（Adobe Font）
    "hbr-drop": {	

    baseImageSelectorName: "カラーを選択",
    baseImages: {			
    "デイジーピンク": "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/hbr-drop-dpk_preview.png",
    "デイジーグリーン": "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/hbr-drop-dgr_preview.png",
    "デイジーパープル": "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/hbr-drop-dpl_preview.png",
    "デイジーイエロー": "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/hbr-drop-dye_preview.png"		
    },
    designImageBaseUrl: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files",
    designComboLayers: [
      {
        id: "static-design",
        zIndex: 10,
       
        keys: [],                   
        images: {"": "preview_without_design.png"}
      }
    ],

    font: {
    name: "arno-pro",
    fontweight: 400,
    textColor: "#563b2c"
    },
   
    textFields: [				
    {				
    inputId: "text-1",
    leftPercent: "47.50%",
    bottomPercent : "86.8%",
    fontSize: "40.99px",
    letterSpacing: "0em",
    align: "center",
    centerY: true,
    writingMode: "horizontal-tb",
    maxWidth: 170,
    allowedChars: "^[A-Za-z0-9.\\-!’' ]+$"		
    },
    {				
    inputId: "select-1",
    leftPercent: "47.49%",
    bottomPercent : "82.8%",
    fontSize: "18.78px",
    letterSpacing: "0em",
    align: "center",
    centerY: true		
    },
    {
     inputId: "text-2",
    leftPercent: "47.50%",
    bottomPercent : "79.8%",
    fontSize: "20.49px",
    letterSpacing: "0em",
    align: "center",
    centerY: true,
    allowedChars: "^[0-9.\\-!’' ]+$"				
    }
	
    ]
    },  
  //ハーバリウム和 FONT OK（Adobe Font）
    "w-hbrm": {	

    baseImageSelectorName: "カラーを選択",
    baseImages: {			
        "ぱーぷる":"https://cdn.shopify.com/s/files/1/0644/6179/9621/files/w-hbrm-p.png",
        "ぴんく":"https://cdn.shopify.com/s/files/1/0644/6179/9621/files/w-hbrm-pk.png",
        "ぐりーん":"https://cdn.shopify.com/s/files/1/0644/6179/9621/files/w-hbrm-g.png"
    },
    designImageBaseUrl: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files",
    designComboLayers: [
    {
    id: "layer-main",
    combination: { 
    keys: [ "select-1"],
    images: { 
        "1.感謝":"w-hbrm-kansya.png",
        "2.寿":"w-hbrm-ktbk.png",
        "3.還暦":"w-hbrm-knrk.png",
        "4.古希":"w-hbrm-koki.png",
        "5.喜寿":"w-hbrm-kiju.png",
        "6.傘寿":"w-hbrm-sanju.png",
        "7.米寿":"w-hbrm-beiju.png",
        "8.卒寿":"w-hbrm-sotsu.png",
        "9.白寿":"w-hbrm-haku.png"
    }}
    }
    ],


    font: {
    name: "sichanagasa",
    fontweight: 400,
    textColor: "#ffffff"
    },
   
    textFields: [				
    {
    inputId: "text-1",
    leftPercent: "37.38%",
    bottomPercent : "24.31%",
    fontSize: "55.62px",
    letterSpacing: "-0.12em",
    align: "center",
    centerY: true,
    writingMode: "horizontal-tb",
    maxWidth: 300			
    }
	
    ]
    },      
    
  //木製ネクタイピン  FONT OK（商用可埋め込み可フリーフォント）
    "woodentie-clip": {
    designImageBaseUrl: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files",
    designComboLayers: [
      {
        id: "static-design",
        zIndex: 10,
        // キー依存なし（常に同じ画像）
        keys: [],                      // ★空配列
        images: {
          "": "preview_without_design.png"  // ★空キーにマッピング
        }
      }
    ],
    baseImageSelectorName: "カラーを選択（木の種類）",
    baseImages: {			
    "花梨": "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/woodentie-clip-krn_base.png",
    "メープル": "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/woodentie-clip-mpl_base.png",
    "ナラ": "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/woodentie-clip-nar_base.png",
    "ウォールナット": "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/woodentie-clip-wnt_base.png",
    "黒檀": "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/woodentie-clip-kkt_base.png"		
    },


    font: {
    name: "arial",
    fontweight: 400,
    textColor: "#020201"
    },

    fontByGPO: {
    "select-2": {
      "英ゴシック": {
          name: "arial",
          fontweight: 400,
          fontSize: "42px"	
      },
      "イタリック": {
        name: "MTCORSVA",
        url: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/MTCORSVA.woff2",
        fontSize: "53px"	
      }
    }
    },


    textFields: [
    {				
    inputId: "text-1",
    rightPercent: "8%",
    align: "right",
    bottomPercent: "49.5%",
    letterSpacing: "0.04em",
    centerY: true,
    ConvertToCursiveFormat: true,//筆記体変換
    fontSize: "42px"				
    }	
    ],

    allowedChars: /^[a-zA-Z0-9\s\-.]+$/, // 例：英数字とハイフン、スペースのみOK
      


    },  
  //2WAY スポーツ リュック FONT OK（商用可埋め込み可フリーフォント）
    "2wbp-sp":{
    baseImageSelectorName: "カラーを選択",
    baseImages: {			
    "ブラック": "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/2wbp-sp-blk.png",
    "ネイビー": "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/2wbp-sp-nvy.png",
    "ホワイト": "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/2wbp-sp-whi.png"		
    },
        designComboLayers: [
    {
    id: "layer-main",
    combination: {
    keys: ["デザインを選択","カラーを選択"], // ← select の id をそのまま
    images: {
        "バスケットボール|ブラック":"2wbp-sp-bsk.png",
        "サッカー|ブラック":"2wbp-sp-scr.png",
        "野球|ブラック":"2wbp-sp-bbl.png",
        "バレーボール|ブラック":"2wbp-sp-vlb.png",
        "ラグビー|ブラック":"2wbp-sp-rgb.png",
        "バスケットボール|ネイビー":"2wbp-sp-bsk.png",
        "サッカー|ネイビー":"2wbp-sp-scr.png",
        "野球|ネイビー":"2wbp-sp-bbl.png",
        "バレーボール|ネイビー":"2wbp-sp-vlb.png",
        "ラグビー|ネイビー":"2wbp-sp-rgb.png",
        "バスケットボール|ホワイト":"2wbp-sp-bsk-w.png",
        "サッカー|ホワイト":"2wbp-sp-scr-w.png",
        "野球|ホワイト":"2wbp-sp-bbl-w.png",
        "バレーボール|ホワイト":"2wbp-sp-vlb-w.png",
        "ラグビー|ホワイト":"2wbp-sp-rgb-w.png"



    }}
    }
    ],  
    designImageBaseUrl: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files",


    font: {				
      name: "collegeb",				
      url: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/collegeb.woff2",				
      textColor: "#ffffff"			
    },	
    
    
    textFields: [				
    {				
    inputId: "text-1",
    leftPercent: "65.89%",
    bottomPercent : "22.84%",
    fontSize: "17.64px",
    letterSpacing: "-0.05em",
    align: "center",
    centerY: true,
    writingMode: "horizontal-tb",
    maxWidth: 120,
    allowedChars: "^[A-Za-z0-9.\\- ]+$",
    font: { name: "college", url: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/college.woff2",textColor: "#ffffff" }				
    },
        {				
    inputId: "text-2",
    leftPercent: "65.80%",
    bottomPercent : "19.28%",
    fontSize: "52.63px",
    letterSpacing: "0em",
    align: "center",
    centerY: true,
    allowedChars: "^[0-9]+$",
    font: { name: "collegeb", url: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/collegeb.woff2",textColor: "#ffffff" }				
    }	
    ],
        designFontMap: {
    "ブラック": { textColor: "#ffffff" },
    "ネイビー": { textColor: "#ffffff" },
    "ホワイト": { textColor: "#000000"}
    }  
    },  

  //パステルカラー キーケース  FONT OK（商用可埋め込み可フリーフォント）
    "pas-key": {
    designImageBaseUrl: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files",
    designComboLayers: [
      {
        id: "static-design",
        zIndex: 10,
        // キー依存なし（常に同じ画像）
        keys: [],                      // ★空配列
        images: {
          "": "preview_without_design.png"  // ★空キーにマッピング
        }
      }
    ],
    baseImageSelectorName: "カラーを選択",
    baseImages: {			
    "ベージュ": "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/pas-key-clip-bag_base.png",
    "ブルー": "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/pas-key-clip-bul_base.png",
    "グレー": "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/pas-key-clip-gry_base.png"
    },


    font: {
    name: "Angelface",
    url: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/Angelface.woff2",
    textColor: "#020201"
    },


    textFields: [
    {				
    inputId: "text-1",
    rightPercent: "8%",
    align: "right",
    bottomPercent: "49.5%",
    letterSpacing: "0.04em",
    centerY: true,
    ConvertToCursiveFormat: true,//筆記体変換
    fontSize: "42px"				
    }	
    ],

    allowedChars: /^[a-zA-Z0-9\s\-.]+$/, // 例：英数字とハイフン、スペースのみOK
      


    },   
         
  //柘植櫛 FONT OK（商用可埋め込み可フリーフォント）
    "tsuge-gushi": {
    designImageBaseUrl: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files",
    designComboLayers: [
      {
        id: "static-design",
        zIndex: 10,
        // キー依存なし（常に同じ画像）
        keys: [],                      // ★空配列
        images: {
          "": "preview_without_design.png"  // ★空キーにマッピング
        }
      }
    ],

    baseImageSelectorName: "カラーを選択",
    baseImages: {			
    "薔薇と蝶": "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/tsuge-gushi-brt_base_preview.png",
    "ふくろう": "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/tsuge-gushi-fkr_base_preview.png",
    "花猫": "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/tsuge-gushi-hnn_base_preview.png",
    "苺": "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/tsuge-gushi-icg_base_preview.png",
    "ネモフィラ": "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/tsuge-gushi-nmf_base_preview.png",
    "桜兎": "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/tsuge-gushi-sku_base_preview.png",
    "椿": "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/tsuge-gushi-tbk_base_preview.png",
    "花と鳥": "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/tsuge-gushi-ttt_base_preview.png"
    },


    font: {
    name: "MTCORSVA",
    url: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/MTCORSVA.woff2",
    textColor: "#38281c"
    },


    textFields: [
      {
        inputId: "text-1",
        // アーチ指定（座標は 800x800 基準）
        // 柘植櫛：上向きの浅いアーチ（中央合わせ）
        arc: {
          cx: 390,      // 中心X
          cy: 995,      // 中心Y（弧の高さ調整）
          r: 650,       // 半径（大きいほど緩やか）
          startDeg: -90,  // 左端（時計回りなので 上左寄り）
          endDeg: 90,    // 右端（上右寄り）
          startOffset: "50%", // 文字列の中央を弧の中央に
          textAnchor: "middle",
          dy: -6         // 弧の外側に出す微調整
        },


        ConvertToCursiveFormat: true,//筆記体変換
        fontSize: "57px",
        letterSpacing: "-0.02em",
        fitRatio: 0.14,                 // ← 弧の 90% に収める（余白）
        allowedChars: "^[A-Za-z\\s\\-]+$"
      }
      ]
      },

  //パドルブラシ   FONT OK（Adobe Font）
    "pdr-bls": {				
              
    baseImage: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/pdr-bls_base.png",				
    designImageBaseUrl: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files",				
    designComboLayers: [
    {
      id: "layer1-msg",          // 任意の識別子
      zIndex: 11,                // ベースの上に重ねる順
      // 位置や回転を微調整したい時は下のコメントを外して調整
      // offset: {x:0, y:0}, rotate: 0, scale: 1, opacity: 1,

      // 複合キー（select-1 × select-2）
      combination: {
        keys: ["select-1", "select-2"],
        images: {
          "HAPPY BIRTHDAY|名入れしない":   "pdr-bls_hpb_no_preview.png",
          "SPECIAL THANKS|名入れしない":  "pdr-bls_spt_no_preview.png",
          "HAPPY WEDDING|名入れしない":   "pdr-bls_hpw_no_preview.png",
          "ANNIVERSARY|名入れしない":     "pdr-bls_ani_no_preview.png",
          "MERRY CHRISTMAS|名入れしない": "pdr-bls_xmas_no_preview.png",
          "THANK YOU MOTHER|名入れしない": "pdr-bls_md_no_preview.png",
          "THANK YOU FATHER|名入れしない": "pdr-bls_fd_no_preview.png",

          "HAPPY BIRTHDAY|名入れする":    "pdr-bls_hpb_preview.png",
          "SPECIAL THANKS|名入れする":   "pdr-bls_spt_preview.png",
          "HAPPY WEDDING|名入れする":    "pdr-bls_hpw_preview.png",
          "ANNIVERSARY|名入れする":      "pdr-bls_ani_preview.png",
          "MERRY CHRISTMAS|名入れする":  "pdr-bls_xmas_preview.png",
          "THANK YOU MOTHER|名入れする": "pdr-bls_md_preview.png",
          "THANK YOU FATHER|名入れする": "pdr-bls_fd_preview.png"
        }
      }
    },
    {
      id: "layer2-flower",
      zIndex: 12,

      // 複合キー（select-4 × select-2）
      combination: {
        keys: ["select-4", "select-2"],
        images: {
          "バラ|名入れしない": "pdr-bls_bara_no_preview.png",
          "ユリ|名入れしない": "pdr-bls_yuri_no_preview.png",
          "バラ|名入れする":   "pdr-bls_bara_preview.png",
          "ユリ|名入れする":   "pdr-bls_yuri_preview.png"
        }
      }
    }
    ],					
              
    font: {
    name: "futura-pt",
    fontweight: 500,
    textColor:"#4c2b14"
    },				

    allowedChars: "^[A-Za-z\\s\\-]+$",
    // 例：日本語＋スペース
      
    textFields: [				
    {				
    inputId: "text-1",//名前
    leftPercent: "47.5%",
    align: "center",
    bottomPercent: "43.5%",
    centerY: true,
    letterSpacing: "0.02em",
    fontSize: "21px",
    maxWidth: 160,
    allowedChars: "^[A-Za-z0-9.\\- ]+$",
			
    }			
    ],


    },
  //パドルブラシミニ   FONT OK（Adobe Font）
    "pdr-bls-mini": {				
              
    baseImage: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/pdr-bls_base.png",				
    designImageBaseUrl: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files",				
    designComboLayers: [
    {
      id: "layer1-msg",          // 任意の識別子
      zIndex: 11,                // ベースの上に重ねる順
      // 位置や回転を微調整したい時は下のコメントを外して調整
      // offset: {x:0, y:0}, rotate: 0, scale: 1, opacity: 1,


      combination: {
        keys: ["select-1", "select-3"],
        images: {
          "HAPPY BIRTHDAY|名入れしない":   "pdr-bls_hpb_no_preview.png",
          "SPECIAL THANKS|名入れしない":  "pdr-bls_spt_no_preview.png",
          "HAPPY WEDDING|名入れしない":   "pdr-bls_hpw_no_preview.png",
          "ANNIVERSARY|名入れしない":     "pdr-bls_ani_no_preview.png",
          "MERRY CHRISTMAS|名入れしない": "pdr-bls_xmas_no_preview.png",
          "THANK YOU MOTHER|名入れしない": "pdr-bls_md_no_preview.png",
          "THANK YOU FATHER|名入れしない": "pdr-bls_fd_no_preview.png",

          "HAPPY BIRTHDAY|名入れする":    "pdr-bls_hpb_preview.png",
          "SPECIAL THANKS|名入れする":   "pdr-bls_spt_preview.png",
          "HAPPY WEDDING|名入れする":    "pdr-bls_hpw_preview.png",
          "ANNIVERSARY|名入れする":      "pdr-bls_ani_preview.png",
          "MERRY CHRISTMAS|名入れする":  "pdr-bls_xmas_preview.png",
          "THANK YOU MOTHER|名入れする": "pdr-bls_md_preview.png",
          "THANK YOU FATHER|名入れする": "pdr-bls_fd_preview.png"
        }
      }
    },
    {
      id: "layer2-flower",
      zIndex: 12,


      combination: {
        keys: ["デザインを選択", "select-3"],
        images: {
          "バラ|名入れしない": "pdr-bls_bara_no_preview.png",
          "ユリ|名入れしない": "pdr-bls_yuri_no_preview.png",
          "バラ|名入れする":   "pdr-bls_bara_preview.png",
          "ユリ|名入れする":   "pdr-bls_yuri_preview.png"
        }
      }
    }
    ],					
              
    font: {
    name: "futura-pt",
    fontweight: 500,
    textColor:"#4c2b14"
    },				

    allowedChars: "^[A-Za-z\\s\\-]+$",
    
      
    textFields: [				
    {				
    inputId: "text-1",//名前
    leftPercent: "47.5%",
    align: "center",
    bottomPercent: "43.5%",
    centerY: true,
    letterSpacing: "0.02em",
    fontSize: "21px",
    maxWidth: 160,
    allowedChars: "^[A-Za-z0-9.\\- ]+$",
			
    }			
    ],


    },
  //パドルブラシミニ  誕生花  FONT OK（Adobe Font）
    "pdr-bls-mini-fl": {				
              
    baseImage: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/pdr-bls-md_base.png",				
    designImageBaseUrl: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files",				
    designComboLayers: [
    {
      id: "layer1-msg",          // 任意の識別子
      zIndex: 11,                // ベースの上に重ねる順
      // 位置や回転を微調整したい時は下のコメントを外して調整
      // offset: {x:0, y:0}, rotate: 0, scale: 1, opacity: 1,


      combination: {
        keys: ["select-3"],
        images: {
        "1月 ツバキ":"pdr-bls-mini-fl_tbk.png",
        "2月 マーガレット":"pdr-bls-mini-fl_mgr.png",
        "3月 ミモザ":"pdr-bls-mini-fl_mimo.png",
        "4月 チューリップ":"pdr-bls-mini-fl_chu.png",
        "5月 スズラン":"pdr-bls-mini-fl_suzu.png",
        "6月 アジサイ":"pdr-bls-mini-fl_aji.png",
        "7月 ラベンダー":"pdr-bls-mini-fl_lab.png",
        "8月 ヒマワリ":"pdr-bls-mini-fl_hima.png",
        "9月 コスモス":"pdr-bls-mini-fl_bor.png",
        "10月 バラ":"pdr-bls-mini-fl_bara.png",
        "11月 マリーゴールド":"pdr-bls-mini-fl_mrg.png",
        "12月 ビオラ":"pdr-bls-mini-fl_csm.png",
        "デザインなし":"preview_without_design.png"

        }
      }
    }
    ],					
              
    font: {
      name: "adobe-handwriting-ernie",
      textColor: "#ffffff",
      fontWeight: "400",
      fontStyle: "normal"
    },		
      
    textFields: [				
    {				
    inputId: "text-1",
    leftPercent: "50%",
    bottomPercent : "38.48%",
    fontSize: "37.74px",
    letterSpacing: "0em",
    align: "left",
    centerY: true,
    writingMode: "horizontal-tb",
    maxWidth: 240,
    paddingRight: "1em",
    ConvertToCursiveFormat: true,//筆記体変換    
    allowedChars: "^[A-Za-z0-9.\\- ]+$"
			
    }			
    ],


    },    
  //パドルブラシ ローズブーケセット  FONT OK（Adobe Font）
    "pdr-bls-rb": {				
              
    baseImage: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/pdr-bls_base.png",				
    designImageBaseUrl: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files",				
    designComboLayers: [
    {
      id: "layer1-msg",          // 任意の識別子
      zIndex: 11,                // ベースの上に重ねる順
      // 位置や回転を微調整したい時は下のコメントを外して調整
      // offset: {x:0, y:0}, rotate: 0, scale: 1, opacity: 1,

      // 複合キー（select-1 × select-2）
      combination: {
        keys: ["select-2", "select-4"],
        images: {
          "HAPPY BIRTHDAY|名入れしない":   "pdr-bls_hpb_no_preview.png",
          "SPECIAL THANKS|名入れしない":  "pdr-bls_spt_no_preview.png",
          "HAPPY WEDDING|名入れしない":   "pdr-bls_hpw_no_preview.png",
          "ANNIVERSARY|名入れしない":     "pdr-bls_ani_no_preview.png",
          "MERRY CHRISTMAS|名入れしない": "pdr-bls_xmas_no_preview.png",
          "THANK YOU MOTHER|名入れしない": "pdr-bls_md_no_preview.png",
          "THANK YOU FATHER|名入れしない": "pdr-bls_fd_no_preview.png",

          "HAPPY BIRTHDAY|名入れする":    "pdr-bls_hpb_preview.png",
          "SPECIAL THANKS|名入れする":   "pdr-bls_spt_preview.png",
          "HAPPY WEDDING|名入れする":    "pdr-bls_hpw_preview.png",
          "ANNIVERSARY|名入れする":      "pdr-bls_ani_preview.png",
          "MERRY CHRISTMAS|名入れする":  "pdr-bls_xmas_preview.png",
          "THANK YOU MOTHER|名入れする": "pdr-bls_md_preview.png",
          "THANK YOU FATHER|名入れする": "pdr-bls_fd_preview.png"
        }
      }
    },
    {
      id: "layer2-flower",
      zIndex: 12,

      // 複合キー（select-4 × select-2）
      combination: {
        keys: ["デザインを選択", "select-4"],
        images: {
          "バラ|名入れしない": "pdr-bls_bara_no_preview.png",
          "ユリ|名入れしない": "pdr-bls_yuri_no_preview.png",
          "バラ|名入れする":   "pdr-bls_bara_preview.png",
          "ユリ|名入れする":   "pdr-bls_yuri_preview.png"
        }
      }
    }
    ],					
              
    font: {
    name: "futura-pt",
    fontweight: 500,	
    textColor:"#4c2b14"
    },				

    allowedChars: "^[A-Za-z\\s\\-]+$",
    // 例：日本語＋スペース
      
    textFields: [				
    {				
    inputId: "text-1",//名前
    leftPercent: "47.5%",
    align: "center",
    bottomPercent: "43.5%",
    centerY: true,
    letterSpacing: "0.02em",
    fontSize: "21px",
    maxWidth: 160,
    allowedChars: "^[A-Za-z0-9.\\- ]+$",
			
    }			
    ],


    },
  //パドルブラシ母の日   FONT OK（Adobe Font）
    "pdr-bls-md": {				
              
    baseImage: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/pdr-bls-md_base.png",				
    designImageBaseUrl: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files",				
        designComboLayers: [
    {
    id: "layer-main",
    combination: {				
    keys: ["select-1"], 				
    images: {				
     "名入れしない":"pdr-bls-md_no_preview.png",
     "名入れする":"pdr-bls-md_preview.png",
     }}
    }
    ],  

	
              
    font: {
    name: "futura-pt",
    fontweight: 500,
    textColor:"#4c2b14"
    },				

    allowedChars: "^[A-Za-z\\s\\-]+$",
    // 例：日本語＋スペース
      
    textFields: [				
    {				
    inputId: "text-1",//名前
    leftPercent: "47.5%",
    align: "center",
    bottomPercent: "42.5%",
    centerY: true,
    letterSpacing: "0.02em",
    fontSize: "21px",
    maxWidth: 160,
    allowedChars: "^[A-Za-z0-9.\\- ]+$",
			
    }			
    ],


    },
  //ミニパドルブラシ母の日   FONT OK（Adobe Font）
    "pdr-bls-mini-md": {				
              
    baseImage: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/pdr-bls-md_base.png",				
    designImageBaseUrl: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files",				
        designComboLayers: [
    {
    id: "layer-main",
    combination: {				
    keys: ["select-1"], 				
    images: {				
     "名入れしない":"pdr-bls-md_no_preview.png",
     "名入れする":"pdr-bls-md_preview.png",
    }}
    }
    ],  

	
              
    font: {
    name: "futura-pt",
    fontweight: 500,		
    textColor:"#4c2b14"
    },				

    allowedChars: "^[A-Za-z\\s\\-]+$",
    // 例：日本語＋スペース
      
    textFields: [				
    {				
    inputId: "text-1",//名前
    leftPercent: "47.5%",
    align: "center",
    bottomPercent: "42.5%",
    centerY: true,
    letterSpacing: "0.02em",
    fontSize: "21px",
    maxWidth: 160,
    allowedChars: "^[A-Za-z0-9.\\- ]+$",
			
    }			
    ],


    },
  //ステンレスZIPPO・バイカー  FONT OK（商用可埋め込み可フリーフォント）
    "zp-t": {	

    baseImage: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/zippo_base.png",
    designImageBaseUrl: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files",
    designComboLayers: [
      {
        id: "design-image",
        zIndex: 1,
        // キー依存なし（常に同じ画像）
        combination: {	
        keys: [],                      // ★空配列
        images: {
          "": "zp-t_preview.png"  // ★空キーにマッピング
        }
        }
      }
    ],

    font: {
    name: "HATTEN",
    url: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/HATTEN.woff2",
    textColor: "#808484"
    },
   
    textFields: [				
        {				
    inputId: "text-1",
    leftPercent: "50.22%",
    bottomPercent : "31.44%",
    fontSize: "76.8px",
    letterSpacing: "-0.01em",
    align: "center",
    centerY: true,
    writingMode: "horizontal-tb",
    maxWidth: 340,
    allowedChars: "^[A-Za-z0-9.\\- ]+$"			
    }
	  ]
    },
  //シルバーネームZIPPO  FONT OK（商用可埋め込み可フリーフォント）
    "zippo_slv": {	

    baseImage: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/zippo_base.png",
    designImageBaseUrl: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files",
    designComboLayers: [
      {
        id: "design-image",
        zIndex: 1,
        // キー依存なし（常に同じ画像）
        combination: {	
        keys: [],                      // ★空配列
        images: {
          "": "preview_without_design.png"  // ★空キーにマッピング
        }
        }
      }
    ],

    font: {
    name: "MTCORSVA",
    url: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/MTCORSVA.woff2",
    textColor: "#c6b560"
    },
   
    textFields: [				
        {				
    inputId: "text-1",
    rightPercent: "26.67%",
    bottomPercent : "12.39%",
    fontSize: "54.09px",
    letterSpacing: "0.05em",
    align: "right",
    centerY: true,
    writingMode: "horizontal-tb",
    maxWidth: 339,
    ConvertToCursiveFormat: true,//筆記体変換
    allowedChars: "^[A-Za-z0-9.\\- ]+$"			
    }
	  ]
    },


    
//===ステーショナリー=============================================================================================================

  //コモノレスト   FONT OK（Adobe Font）
    "komono-rest": {	

    baseImages: {			
    "メープル": "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/komono-rest_map_base_preview2.png",				
    "ウォールナット": "https://cdn.shopify.com/s/files/1/0644/6179/9621/files/komono-rest_wnt_base_preview2.png"				
    },
    baseImageSelectorName: "カラーを選択",
    designImageBaseUrl: "https://cdn.shopify.com/s/files/1/0644/6179/9621/files",
        designComboLayers: [
    {
    id: "layer-main",
    combination: {
    keys: ["select-1", "select-3"], 
    images: {
      "1.ThankYou|サンセリフ（ローマ字のみ）": "komono-rest_preview_1_san.png",
      "1.ThankYou|ローマン（ローマ字のみ）": "komono-rest_preview_1_rom.png",
      "2.HappyBirthDay|サンセリフ（ローマ字のみ）": "komono-rest_preview_2_san.png",
      "2.HappyBirthDay|ローマン（ローマ字のみ）": "komono-rest_preview_2_rom.png",
      "3.HappyAnniversary|サンセリフ（ローマ字のみ）": "komono-rest_preview_3_san.png",
      "3.HappyAnniversary|ローマン（ローマ字のみ）": "komono-rest_preview_3_rom.png",
      "4.HappyWedding|サンセリフ（ローマ字のみ）": "komono-rest_preview_4_san.png",
      "4.HappyWedding|ローマン（ローマ字のみ）": "komono-rest_preview_4_rom.png",
      "メッセージなし|サンセリフ（ローマ字のみ）": "komono-rest_preview_5.png",
      "メッセージなし|ローマン（ローマ字のみ）": "komono-rest_preview_5.png"
    }}
    }
    ],  

    font: {
    name: "calibri",
    fontweight: 300,
    textColor: "#352201"
    },

    fontByGPO: {
    "select-3": {
      "サンセリフ（ローマ字のみ）": {
        name: "calibri",
        fontweight: 300,
        textColor: "#352201",
        fontSize: "37px"
      },
      "ローマン（ローマ字のみ）": {
        name: "minion-pro",
        fontweight: 700,
        textColor: "#352201",
        fontSize: "33px"
      }
    }
    },


    textFields: [
    {				
    inputId: "text-1",
    rightPercent: "7%",
    align: "right",
    bottomPercent: "13%",
    fontSize: "35px"				
    }	
    ],

    allowedChars: /^[a-zA-Z0-9\s\-.]+$/, // 例：英数字とハイフン、スペースのみOK
      
    },


    };	

//
/*設定補助～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～


  textFields: [
  {
  inputId: "text-1",
  leftPercent: "50%", 
  align: "center",中央揃え
  centerY: true,  ✅ このフラグがあると上下中央化される
  bottomPercent : "25%",
  fontSize: "48px",
  letterSpacing: "0.1em",文字間広げる
  maxWidth: 300,
   maxHeight: 200,
  ConvertToCursiveFormat: true,筆記体変換
   writingMode: "vertical-rl"縦書き
  }
  ]


    allowedChars: /^[\u3040-\u309F\u30A0-\u30FF\u4E00-\u9FAF0-9０-９\s　]+$/,  例：日本語＋数字＋スペース
    allowedChars: /^[a-zA-Z0-9\s\-]+$/,  例：英数字とハイフン、スペースのみOK
    allowedChars: /^[0-9]+$/,
    allowedChars: /^[0-9.]+$/,
    allowedChars: /^[A-Za-z0-9.\\-]+$/, 
    allowedChars: /^[\u3040-\u30FF\u4E00-\u9FAFa-zA-Z0-9\s\-]+$/,  日本語と英数字OK

  designCombination: "design|style",  または "design|color"

  ～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～
        designComboLayers: [
    {
    id: "layer-main",
    combination: {
     keys: ["select-1", "select-3"], 
    images: {
        "1.ThankYou|サンセリフ（ローマ字のみ）": "komono-rest_preview_1_san.png",
        "1.ThankYou|ローマン（ローマ字のみ）": "komono-rest_preview_1_rom.png",
        "2.HappyBirthDay|サンセリフ（ローマ字のみ）": "komono-rest_preview_2_san.png",
        "2.HappyBirthDay|ローマン（ローマ字のみ）": "komono-rest_preview_2_rom.png",
        "3.HappyAnniversary|サンセリフ（ローマ字のみ）": "komono-rest_preview_3_san.png",
        "3.HappyAnniversary|ローマン（ローマ字のみ）": "komono-rest_preview_3_rom.png",
        "4.HappyWedding|サンセリフ（ローマ字のみ）": "komono-rest_preview_4_san.png",
        "4.HappyWedding|ローマン（ローマ字のみ）": "komono-rest_preview_4_rom.png",
        "メッセージなし|サンセリフ（ローマ字のみ）": "komono-rest_preview_5.png",
        "メッセージなし|ローマン（ローマ字のみ）": "komono-rest_preview_5.png"
    }}
    }
    ], 



  デザイン選択によって文字位置切り替え～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～
  designTextPositionMap: {
    "父の日ヒゲ": [
      { leftPercent: "20%", bottomPercent: "15%", align: "left" }
    ],
    "父の日ネクタイ": [
     { rightPercent: "10%", bottomPercent: "10%", align: "right" }
    ]
  },

  デザイン選択によって文字位置切り替え～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～
  designTextPositionMap: {
        "1.ThankYou|サンセリフ（ローマ字のみ）": [{ leftPercent: "10%", bottomPercent: "15%", align: "left" }],
        "1.ThankYou|ローマン（ローマ字のみ）": [{ leftPercent: "10%", bottomPercent: "30%", align: "left" }],
        "2.HappyBirthDay|サンセリフ（ローマ字のみ）":[{ leftPercent: "20%", bottomPercent: "15%", align: "left" }],
        "2.HappyBirthDay|ローマン（ローマ字のみ）": [{ leftPercent: "20%", bottomPercent: "30%", align: "left" }],
        "3.HappyAnniversary|サンセリフ（ローマ字のみ）":[{ leftPercent: "30%", bottomPercent: "15%", align: "left" }],
        "3.HappyAnniversary|ローマン（ローマ字のみ）":[{ leftPercent: "30%", bottomPercent: "30%", align: "left" }],
        "4.HappyWedding|サンセリフ（ローマ字のみ）":[{ leftPercent: "40%", bottomPercent: "15%", align: "left" }],
        "4.HappyWedding|ローマン（ローマ字のみ）":[{ leftPercent: "40%", bottomPercent: "30%", align: "left" }],
        "メッセージなし|サンセリフ（ローマ字のみ）":[{ leftPercent: "50%", bottomPercent: "15%", align: "left" }],
        "メッセージなし|ローマン（ローマ字のみ）":[{ leftPercent: "50%", bottomPercent: "30%", align: "left" }]
  },

  入力内容 日本語と英語でフォント切り替え
      font: {
      jp: {
        name: "HGPMinchoB-02",
        url: "https:cdn.shopify.com/s/files/1/0644/6179/9621/files/HGPMinchoB-02.woff2"
      },
      en: {
        name: "ACaslonPro-Bold",
        url: "https:cdn.shopify.com/s/files/1/0644/6179/9621/files/ACaslonPro-Bold.woff2"
      },
      textColor: "#7d5941"
      },
      fontByContent: {
      use: true,
      jpFont: "HGPMinchoB-02",
      enFont: "ACaslonPro-Bold",
      jpLetterSpacing: "0.1em",
      enLetterSpacing: "0.01em"
      },
      textFields: [
      {
        inputId: "text-1",
        leftPercent: "47%", 
        align: "center",
        bottomPercent : "40%",
        fontSize: "43.5px",
        letterSpacing: "0.05em",
        maxWidth: 470
      }
      ]


   ここまで各商品番号ごとの設定～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～
  */


//
// ここから処理コード～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～
// 要素が出てくるまで待つ関数
function waitForElement(selector, maxRetries = 10, interval = 300) {
    return new Promise((resolve, reject) => {
      let retries = 0;
      const timer = setInterval(() => {
        const el = document.querySelector(selector);
        if (el) {
          clearInterval(timer);
          resolve(el);
        } else if (++retries >= maxRetries) {
          clearInterval(timer);
          reject(`❌ 要素が見つかりませんでした: ${selector}`);
        }
      }, interval);
    });
  }
const adjustFontSize = (display, t) => {
  const maxWidth  = t.maxWidth  || Infinity;
  const maxHeight = t.maxHeight || Infinity;
  const initialFontSize = t.fontSize ? parseFloat(t.fontSize) : 28;

  let fontSize = initialFontSize;

  display.style.fontSize = fontSize + 'px';
  display.style.visibility = 'hidden';
  display.style.display = 'inline-block';
  display.style.overflow = 'visible';

  // --- まず縮小ループ ---
  while ((display.scrollWidth > maxWidth || display.scrollHeight > maxHeight) && fontSize > 8) {
    fontSize -= 1;
    display.style.fontSize = fontSize + 'px';
  }

  // --- 次に拡大ループ ---
  while (
    fontSize < initialFontSize &&
    display.scrollWidth <= maxWidth &&
    display.scrollHeight <= maxHeight
  ) {
    fontSize += 1;
    display.style.fontSize = fontSize + 'px';
    if (display.scrollWidth > maxWidth || display.scrollHeight > maxHeight) {
      fontSize -= 1;
      display.style.fontSize = fontSize + 'px';
      break;
    }
  }

  display.style.visibility = '';
  display.style.display = '';
  display.style.overflow = 'hidden';
  };


function ConvertToCursiveFormat(inputText) {
  if (!inputText) return "";

  const parts = inputText.split(/[.\s]+/);

  const formatted = parts.map(part => {
    if (part.length === 0) return "";
    return part.charAt(0) + part.slice(1).toLowerCase();
  });

  let rebuilt = '';
  let lastIndex = 0;

  const delimiters = [...inputText.matchAll(/[.\s]+/g)].map(match => match[0]);

  formatted.forEach((word, index) => {
    rebuilt += word;
    if (delimiters[index]) rebuilt += delimiters[index];
  });

  return rebuilt;
  }




function extractGPOValue(v){
  if (v == null) return "";
  try {
    const o = typeof v === "string" ? JSON.parse(v) : v;
    if (o && typeof o === "object" && "value" in o) return String(o.value);
  } catch(_) {}
  return String(v).trim();
  }

function ensureFontFaceOnce(font) {
  if (!font || !font.name || !font.url) return;
  const id = `ff-${font.name}`;
  if (document.getElementById(id)) return; // 二重登録防止
  const style = document.createElement('style');
  style.id = id;
  style.innerHTML = `
    @font-face {
      font-family: '${font.name}';
      src: url('${font.url}') format('woff2');
      font-display: swap;
    }
  `;
  document.head.appendChild(style);
  }
// fitToBox 用：ルール取得（800px基準 → 実サイズに換算）
function getFitToBoxConfig(frameConfig, textContent) {
  if (!frameConfig.fitToBoxRules) return null;

  const len = textContent.length;
  for (const rule of frameConfig.fitToBoxRules) {
    if (len <= rule.maxLength) {
      const container = document.querySelector('.engrave-preview-container');
      if (!container) return rule; // container が無い場合は素通し

      // 800px 基準 → 実表示サイズへ変換
      const scaleX = container.clientWidth / 800;
      const scaleY = container.clientHeight / 800;

      return {
        width: rule.width * scaleX,
        height: rule.height * scaleY
      };
    }
  }
  return null;
  }



  // --- SVG arc helpers (createArcField より前に置く) ---
function describeArc(cx, cy, r, startDeg, endDeg) {
  const start = polarToCartesian(cx, cy, r, startDeg); // ← 始点を startDeg
  const end   = polarToCartesian(cx, cy, r, endDeg);   // ← 終点を endDeg
  const largeArcFlag = Math.abs(endDeg - startDeg) <= 180 ? "0" : "1";
  const sweepFlag    = endDeg > startDeg ? "1" : "0";  // end が大きいほど時計回り
  return `M ${start.x} ${start.y} A ${r} ${r} 0 ${largeArcFlag} ${sweepFlag} ${end.x} ${end.y}`;
  } 


function polarToCartesian(centerX, centerY, radius, angleInDegrees) {
  var angleInRadians = (angleInDegrees-90) * Math.PI / 180.0;

  return {
    x: centerX + (radius * Math.cos(angleInRadians)),
    y: centerY + (radius * Math.sin(angleInRadians))
  };
  }


// 先頭付近のヘルパーに追加 or 置換
function esc(sel) {
  try {
    return (window.CSS && CSS.escape) ? CSS.escape(sel) : String(sel).replace(/"/g, '\\"');
  } catch {
    return String(sel);
  }
  }
// ★差し替え：designFontMap から来たフォントを強制適用できるよう強化
function applyFontToPreview(fontSetting, textFields, {force = true, reason = "designFontMap"} = {}) {
  if (!fontSetting) return;

  // 1) @font-face を事前登録
  if (fontSetting.url && fontSetting.name) ensureFontFaceOnce(fontSetting);

  // 2) 各テキスト枠へ適用
  textFields.forEach((t, i) => {
    const el = document.getElementById(`engrave-text-${i}`);
    if (!el) return;

    // 個別フィールドが font 指定を持っている場合でも、designFontMap を優先したいときは force=true
    if (!force && t.font && t.font.name) return;

    // フォント名
    if (fontSetting.name) {
      // ← 競合を避けるため important で上書き
      el.style.setProperty('font-family', `'${fontSetting.name}'`, 'important');
    }

    // 色やサイズがあれば反映（任意）
    if (fontSetting.textColor) {
      el.style.setProperty('color', fontSetting.textColor, 'important');
    }
    if (fontSetting.fontSize) {
      el.style.setProperty('font-size', fontSetting.fontSize, 'important');
      t.fontSize = fontSetting.fontSize;
    }
    if (fontSetting.letterSpacing) {
      el.style.letterSpacing = fontSetting.letterSpacing;
    }
    if (fontSetting.writingMode) {
      el.style.writingMode = fontSetting.writingMode;
    }
      // ★ padding の指定があれば反映
  if (config.paddingLeft) {
    displayEl.style.paddingLeft = config.paddingLeft;
  }
  if (config.paddingRight) {
    displayEl.style.paddingRight = config.paddingRight;
  }

    // 自動リサイズ
    if (typeof adjustFontSize === 'function') {
      adjustFontSize(el, t);
    }
  });

  // 記録（後で上書きされたかを検知用）
  console.log(`[font] applied by ${reason}:`, fontSetting.name);
  window.__lastDesignFont__ = fontSetting.name;
  }

// プレースホルダや空白を空扱いに
function normalizeToken(v) {
  const s = String(v ?? "").trim();
  if (!s) return "";
  if (/^--.*選択.*--$/.test(s)) return ""; // 例: "-- 選択してください --"
  return s;
  }

// ★値取得を強化（id→name[radio]→id(select)の順で試す）
function readCurrentValue(nameOrId) {
  // id 直接
  const byId = document.getElementById(nameOrId);
  if (byId) return normalizeToken(extractGPOValue(byId.value));

  // name= のラジオグループ
  const radios = document.querySelectorAll(`input[name="${esc(nameOrId)}"]`);
  if (radios && radios.length) {
    const checked = document.querySelector(`input[name="${esc(nameOrId)}"]:checked`);
    return normalizeToken(checked ? extractGPOValue(checked.value) : "");
  }

  // id と name がズレてるケースのフォールバック：id= を持つ select 等
  const sel = document.querySelector(`#${esc(nameOrId)}`);
  if (sel) return normalizeToken(extractGPOValue(sel.value));

  // さらに name= の select も見ておく
  const selByName = document.querySelector(`select[name="${esc(nameOrId)}"]`);
  if (selByName) return normalizeToken(extractGPOValue(selByName.value));

  return "";
  }


// designComboLayers から、イベント対象となる全キー（name/id）をユニオンで収集
function collectAllDesignKeys(config) {
  const keys = new Set();
  (config.designComboLayers || []).forEach(layer => {
    const ks = layer?.combination?.keys || layer?.keys || [];
    ks.forEach(k => keys.add(k));
  });
  return Array.from(keys);
  }

function resolveComboKey(config, layerId /* optional */) {
  if (!Array.isArray(config.designComboLayers)) return "";

  let layer = null;
  if (layerId) layer = config.designComboLayers.find(l => l.id === layerId);
  if (!layer)
    layer = config.designComboLayers.find(l => Array.isArray(l?.combination?.keys) && l.combination.keys.length > 0);
  if (!layer || !Array.isArray(layer?.combination?.keys)) return "";

  const parts = layer.combination.keys.map(k => {
    const v = readCurrentValue(k);
    console.log("[design] key =", k, "→", v);   // ★ここで見える
    return v;
  });

  const nonEmpty = parts.filter(Boolean);
  const key = nonEmpty.length ? parts.join("|") : "";
  console.log("[design] comboKey:", key);
  return key;
  }


// 現在の全トークン（複合を構成する各値）も欲しい時に
function resolveTokens(config) {
  return collectAllDesignKeys(config).map(k => readCurrentValue(k).trim()).filter(Boolean);
  }

// ★差し替え【新規追加】デザイン依存の 文字位置＆フォントを一括適用
function applyDesignDrivenTextAndFont(config) {
  // ★ まず comboKey を安全に解決
  const comboKey =
    resolveComboKey(config, "layer-main") ||
    resolveComboKey(config) ||
    "";

    console.log("[design] comboKey:", comboKey);
  console.log("[design] tokens:", comboKey ? comboKey.split("|") : resolveTokens(config));


  // ★ テキスト要素を先に取っておく
  const textEls = (config.textFields || []).map((_, i) => document.getElementById(`engrave-text-${i}`));

  // ---- 文字位置（designTextPositionMap）----
  if (config.designTextPositionMap) {
    let positions = undefined; // ← 先に宣言（ReferenceError対策）

    // (A) 複合キー完全一致
    if (comboKey && (comboKey in config.designTextPositionMap)) {
      positions = config.designTextPositionMap[comboKey];
    }

    // (B) 複合トークン（"A|B" → ["A","B"]）か、全キーから単体一致
    if (positions === undefined) {
      const tokens = comboKey
        ? comboKey.split("|").filter(Boolean)
        : resolveTokens(config); // ← designComboLayers 内の全キーの現在値
      for (const t of tokens) {
        if (t in config.designTextPositionMap) {
          positions = config.designTextPositionMap[t];
          break;
        }
      }
    }

    // (C) 旧式：ラジオのラベル名でのフォールバック
    if (positions === undefined && config.designImageSelectorName) {
      const selected = document.querySelector(`input[name="${CSS.escape(config.designImageSelectorName)}"]:checked`);
      if (selected) {
        const labelEl = document.querySelector(`label[for="${selected.id}"]`);
        const labelText = labelEl ? labelEl.textContent.trim() : "";
        if (labelText && (labelText in config.designTextPositionMap)) {
          positions = config.designTextPositionMap[labelText];
        }
      }
    }

    // (D) 適用
    if (positions === null) {
      // 仕様：null → 非表示
      textEls.forEach(el => { if (el) el.style.opacity = "0"; });
    } else if (Array.isArray(positions)) {
      textEls.forEach(el => { if (el) el.style.opacity = ""; }); // 表示に戻す
      positions.forEach((pos, i) => {
        const el = textEls[i];
        if (!el) return;

        // left / right
        if (pos.leftPercent != null) { el.style.left = pos.leftPercent; el.style.right = ""; }
        else if (pos.rightPercent != null) { el.style.right = pos.rightPercent; el.style.left = ""; }
        else if ((pos.align || config.textFields?.[i]?.align) === "center") {
          // ★ center で left/right が無ければ強制的に 50% に（今回のズレ対策）
          el.style.left = "50%"; el.style.right = "";
        }

        el.style.bottom = pos.bottomPercent || '15%';
        el.style.textAlign = pos.align || 'center';
        el.style.transform = (pos.align === 'center' ? 'translateX(-50%)' : '');
        if (pos.fontSize != null) el.style.fontSize = pos.fontSize;
        if (pos.maxHeight != null) el.style.maxHeight = `${pos.maxHeight}px`;
        if (pos.writingMode != null) el.style.writingMode = pos.writingMode;

        // textFields にも反映（auto-resize 用）
        if (config.textFields && config.textFields[i]) {
          const tf = config.textFields[i];
          if (pos.fontSize != null)  tf.fontSize  = pos.fontSize;
          if (pos.maxWidth != null)  tf.maxWidth  = pos.maxWidth;
          if (pos.maxHeight != null) tf.maxHeight = pos.maxHeight;
          if (pos.leftPercent != null)  tf.leftPercent  = pos.leftPercent;
          if (pos.rightPercent != null) tf.rightPercent = pos.rightPercent;
          if (pos.align != null)        tf.align        = pos.align;
          if (pos.bottomPercent != null)tf.bottomPercent= pos.bottomPercent;
          if (pos.writingMode != null)  tf.writingMode  = pos.writingMode;
        }

        if (typeof adjustFontSize === "function") {
          adjustFontSize(el, config.textFields[i]);
        }
      });
    } else {
      // positions が undefined → マッチ無し。何もしない（表示も触らない）
    }
  }

  // ---- フォント（designFontMap）----
  if (config.designFontMap) {
    let fontSetting = undefined;

    if (comboKey && (comboKey in config.designFontMap)) {
      fontSetting = config.designFontMap[comboKey];
    }
    if (!fontSetting) {
      const tokens = comboKey
        ? comboKey.split("|").filter(Boolean)
        : resolveTokens(config);
      for (const t of tokens) {
        if (t in config.designFontMap) { fontSetting = config.designFontMap[t]; break; }
      }
    }
    if (!fontSetting && config.designImageSelectorName) {
      const selected = document.querySelector(`input[name="${CSS.escape(config.designImageSelectorName)}"]:checked`);
      if (selected) {
        const labelEl = document.querySelector(`label[for="${selected.id}"]`);
        const labelText = labelEl ? labelEl.textContent.trim() : "";
        if (labelText && (labelText in config.designFontMap)) {
          fontSetting = config.designFontMap[labelText];
        }
      }
    }
    if (fontSetting) applyFontToPreview(fontSetting, config.textFields);
  }
  }



//デザイン変更に反応して一括で再適用
function setupDesignDrivenBindings(config) {
  const designKeys = collectAllDesignKeys(config);
  const waits = [];

  // すべてのキー要素が現れるまで待つ
  designKeys.forEach(k => {
    waits.push(waitForElement(`#${esc(k)}, input[name="${esc(k)}"]`).catch(() => null));
  });
  if (config.designImageSelectorName) {
    waits.push(waitForElement(`input[name="${esc(config.designImageSelectorName)}"]`).catch(() => null));
  }

  Promise.all(waits).then(() => {
    // ラジオ(name=) と id= に両方バインド
    designKeys.forEach(k => {
      document.querySelectorAll(`input[name="${esc(k)}"]`)
        .forEach(r => r.addEventListener("change", () => applyDesignDrivenTextAndFont(config)));
      const byId = document.getElementById(k);
      if (byId) byId.addEventListener("change", () => applyDesignDrivenTextAndFont(config));
    });

    if (config.designImageSelectorName) {
      document.querySelectorAll(`input[name="${esc(config.designImageSelectorName)}"]`)
        .forEach(r => r.addEventListener("change", () => applyDesignDrivenTextAndFont(config)));
    }

    // 初回適用（この時点なら値が取れる）
    applyDesignDrivenTextAndFont(config);
  });
  }




  //



document.addEventListener('DOMContentLoaded', function () {
    const wrapper = document.getElementById('engraving-preview-wrapper');
    if (!wrapper) return;

    const handle = wrapper.dataset.productHandle;
    if (!handle) return;

    const config = window.engravingProductConfigs?.[handle];
    if (!config) {
      console.error("商品設定が見つかりませんでした:", handle);
      wrapper.innerHTML = '<p>プレビューを読み込めませんでした。</p>';
      return;
    }


    
    renderPreview(config);
        

function renderPreview(config) {
  // 1) 単独/複合デザイン用の初期URL（単独プレビューのフォールバック）
  let designImageSrc = "";
  if (config.designCombination) {
    const key = (config.designCombination.keys || []).map(id => {
      const el = document.getElementById(id);
      return el ? extractGPOValue(el.value) : "";
    }).join("|");
    const filename = config.designCombination.images[key];
    if (filename) designImageSrc = `${config.designImageBaseUrl}/${filename}`;
  } else if (config.designImages?.length) {
    designImageSrc = `${config.designImageBaseUrl}/${config.designImages[0].filename}`;
  }

  // 2) レイヤーHTML（ある場合のみ）
  let designLayersHtml = "";
  if (Array.isArray(config.designComboLayers) && config.designComboLayers.length) {
    designLayersHtml = config.designComboLayers.map(layer => {
      const id = `design-layer-${layer.id}`;
      const zi = layer.zIndex ?? 10;
      const op = layer.opacity ?? 1;
      const tx = layer.offset?.x || 0;
      const ty = layer.offset?.y || 0;
      const rot = layer.rotate || 0;
      const sc  = layer.scale  || 1;
      return `
        <img class="design-layer" id="${id}" alt="${layer.id}"
          style="
            position:absolute; left:0; top:0; width:100%; height:auto;
            z-index:${zi}; opacity:${op};
            transform: translate(${tx}px, ${ty}px) rotate(${rot}deg) scale(${sc});
            pointer-events:none;">
      `;
    }).join("");
  }

  // 3) コンテナ生成（ここで初めて作る）
  const container = document.createElement('div');
  container.className = 'engrave-preview-container';
  Object.assign(container.style, {
    position: 'relative', width: '800px', height: '800px', overflow: 'hidden'
  });

  // 4) innerHTML は1回だけ！
  container.innerHTML = `
    <img class="base" src="${config.baseImage}" alt="ベース画像">
    ${ designLayersHtml || `<img class="design" id="engrave-design" src="${designImageSrc || ''}" alt="デザイン画像">` }
    ${ (config.textFields || []).map((t, i) => {
      if (t.arc) return `<div id="engrave-text-${i}" class="engrave-preview-arc-placeholder"></div>`;
      return `
        <div class="engrave-preview-text" id="engrave-text-${i}" style="
          ${t.leftPercent ? `left:${t.leftPercent};` : (!t.leftPercent && t.rightPercent ? `right:${t.rightPercent};` : '')}
          ${t.topPercent ? `top: ${t.topPercent};` : `bottom: ${t.bottomPercent || '15%'};`}
          ${t.fontSize ? `font-size:${t.fontSize};` : ''}
          font-family:'${(config.font && (config.font.name || config.font.jp?.name || config.font.en?.name)) || 'sans-serif'}';
          color:${config.font.textColor || '#000'};
          text-align:${t.align || 'center'};
          transform:${t.align === 'center' ? 'translateX(-50%)' : ''} ${t.rotate ? `rotate(${t.rotate})` : ''};
          ${t.writingMode ? `writing-mode:${t.writingMode};` : ''}
          ${t.letterSpacing ? `letter-spacing:${t.letterSpacing};` : ''}
          ${t.maxHeight ? `max-height:${t.maxHeight}px;` : ''}
          ${t.paddingLeft ? `padding-left:${t.paddingLeft};` : ''}
          ${t.paddingRight ? `padding-right:${t.paddingRight};` : ''}
          overflow:hidden; position:absolute;
          z-index: 100;   
          ">
        </div>`;
    }).join('') }
  `;

  // 5) アーチ置換
  const arcRefs = {};
  (config.textFields || []).forEach((t, i) => {
    if (!t.arc) return;
    const ph = container.querySelector(`#engrave-text-${i}.engrave-preview-arc-placeholder`);
    if (!ph) return;
    const ref = createArcField(i, t);
    ph.replaceWith(ref.wrap);
    arcRefs[i] = ref;
  });
  config._arcRefs = arcRefs;

  // 6) 置き換え
  wrapper.innerHTML = '';
  wrapper.appendChild(container);

  // 7) 個別フォント優先
  (config.textFields || []).forEach((t, i) => {
     if (t.arc) return;
    const el = document.getElementById(`engrave-text-${i}`);
    if (!el) return;
    if (t.font?.name) {
      ensureFontFaceOnce(t.font);
      el.style.fontFamily = t.font.name;
    } else if (t.fontFamily) {
      el.style.fontFamily = t.fontFamily;
    }
  });

  // 8) フォント読み込み（既存のまま）
  const style = document.createElement('style');
  if (config.font.jp && config.font.en) {
    style.innerHTML = `
      @font-face { font-family:'${config.font.jp.name}'; src:url('${config.font.jp.url}') format('woff2'); font-display:swap; }
      @font-face { font-family:'${config.font.en.name}'; src:url('${config.font.en.url}') format('woff2'); font-display:swap; }
    `;
  } else if (config.font.name && config.font.url) {
    style.innerHTML = `
      @font-face { font-family:'${config.font.name}'; src:url('${config.font.url}') format('woff2'); font-display:swap; }
    `;
  }
  document.head.appendChild(style);

  // 9) 各種セットアップ（layers→design→base→font の順でOK）
  setupTextSync(config);
  setupDesignComboLayersChange(config);  // ← レイヤー用
  setupDesignChange(config);             // ← 単独/複合 旧式用
  setupBaseImageChange(config);
  setupFontChange(config);
  setupDesignDrivenBindings(config); 
  setupCursorMagnifier(wrapper.querySelector('.engrave-preview-container'));
  }

  
function applyTextPositionFromDesign(comboKey, config) {
  console.log("📍 applyTextPositionFromDesign 呼び出し:", comboKey);

    if (!config.designTextPositionMap) {
      console.warn("⚠️ designTextPositionMap が未定義です");
      return;
    }
  //    console.log("🔍 designTextPositionMap キー一覧:", Object.keys(config.designTextPositionMap));
  //  console.log("📦 comboKeyに対応する位置:", config.designTextPositionMap[comboKey]);

    const positions = config.designTextPositionMap[comboKey];

  //  console.log("🔍 positions 取得結果:", positions); // ←これを追加！
  //  console.log("🔎 テキスト位置切替キー:", comboKey);
    if (!positions) {
      console.warn("⚠️ テキスト位置が見つかりません:", comboKey);
      return;
    }

    positions.forEach((pos, i) => {
    const textEl = document.getElementById(`engrave-text-${i}`);
    if (!textEl) return;

    // style更新
    if (pos.leftPercent != null) { textEl.style.left = pos.leftPercent; textEl.style.right = ''; }
    else if (pos.rightPercent != null) { textEl.style.right = pos.rightPercent; textEl.style.left = ''; }
    textEl.style.bottom = pos.bottomPercent || '15%';
    textEl.style.textAlign = pos.align || 'center';
    textEl.style.transform = pos.align === 'center' ? 'translateX(-50%)' : '';
    if (pos.fontSize != null) textEl.style.fontSize = pos.fontSize;
    if (pos.maxHeight != null) textEl.style.maxHeight = `${pos.maxHeight}px`;
    if (pos.writingMode != null) textEl.style.writingMode = pos.writingMode;
    if (pos.paddingLeft != null)  textEl.style.paddingLeft = pos.paddingLeft;
    if (pos.paddingRight != null) textEl.style.paddingRight = pos.paddingRight;


    // --- ★ ここ重要！textFields側の情報も「designTextPositionMap」を必ずコピー ---
    if (config.textFields && config.textFields[i]) {
      if (pos.fontSize != null)  config.textFields[i].fontSize  = pos.fontSize;
      if (pos.maxWidth != null)  config.textFields[i].maxWidth  = pos.maxWidth;
      if (pos.maxHeight != null) config.textFields[i].maxHeight = pos.maxHeight;
      if (pos.leftPercent != null)  config.textFields[i].leftPercent  = pos.leftPercent;
      if (pos.rightPercent != null) config.textFields[i].rightPercent = pos.rightPercent;
      if (pos.align != null)        config.textFields[i].align        = pos.align;
      if (pos.bottomPercent != null)config.textFields[i].bottomPercent= pos.bottomPercent;
      if (pos.writingMode != null)  config.textFields[i].writingMode  = pos.writingMode;
    }
    adjustFontSize(textEl, config.textFields[i]); // ←ここで統一
  });


  }

function applyFontFromDesign(config) {
  //  console.log("▶️ applyFontFromDesign 実行開始");
  //  console.log("🧾 config.designCombination:", config.designCombination);
  //  console.log("🚨 applyTextPositionFromDesign is", typeof applyTextPositionFromDesign);

  const designInputsReady = (config.designCombination?.keys || []).map(id =>
    waitForElement(`#${id}, input[name="${id}"]`) 
  );

  Promise.all(designInputsReady)
    .then(() => {
  //      console.log("✅ 全 designCombination キーの要素が存在");

      // 🔠 フォントの適用処理（従来通り）
      const selected = document.querySelector(`input[name="${config.designImageSelectorName}"]:checked`);
      let selectedLabel = '';
      if (selected) {
        const labelEl = document.querySelector(`label[for="${selected.id}"]`);
        selectedLabel = labelEl ? labelEl.textContent.trim() : '';
        const font = config.designFontMap[selectedLabel];
        if (font) {
          applyFontToPreview(font, config.textFields);
        console.log("🔠 デザイン連動フォント切替:", selectedLabel, font.name);
        } else {
          console.warn("⚠️ フォント未設定:", selectedLabel);
        }
      } else {
  //        console.warn("❌ 選択された designImage が見つかりません");
      }

      // 🔠 GPO連動のフォント（fontByGPO）適用処理
      if (config.fontByGPO) {
        Object.entries(config.fontByGPO).forEach(([gpoName, options]) => {
          const safeName = window.CSS && CSS.escape ? CSS.escape(gpoName) : gpoName.replace(/"/g, '\\"');
          const groupSelector = `input[name="${safeName}"]`;

          const applyFont = () => {
            // ✅ ラジオ優先で現在値を取得（無ければ select 等の #id を見る）
            const selected =
              document.querySelector(`${groupSelector}:checked`)?.value
              ?? document.getElementById(gpoName)?.value
              ?? '';
            const setting = options[selected];
            if (!setting) return;

            // 適用（色は上書き勝たせたいので !important 推奨）
            config.textFields.forEach((t, i) => {
              const el = document.getElementById(`engrave-text-${i}`);
              if (!el) return;

              if (setting.name) el.style.fontFamily = setting.name;
              if (setting.fontSize) {
                el.style.fontSize = setting.fontSize;
                // 自動縮小の基準も更新しておく
                t.baseFontSize = setting.fontSize;
                t.fontSize = setting.fontSize;
                if (typeof adjustFontSize === 'function') adjustFontSize(el, t);
              }
              if (setting.letterSpacing) el.style.letterSpacing = setting.letterSpacing;
              if (setting.writingMode)  el.style.writingMode  = setting.writingMode;
              if (setting.textColor)   el.style.setProperty('color', setting.textColor, 'important');
            });

            // 追加で @font-face が必要なら読み込み
            if (setting.url && setting.name) {
              const style = document.createElement('style');
              style.innerHTML = `
                @font-face {
                  font-family: '${setting.name}';
                  src: url('${setting.url}') format('woff2');
                  font-display: swap;
                }
              `;
              document.head.appendChild(style);
            }
          };

          // 初期バインド：グループの全ラジオへ
          const tryBind = (retry = 0) => {
            const radios = document.querySelectorAll(groupSelector);
            const idEl   = document.getElementById(gpoName); // select 等のフォールバック

            if (radios.length === 0 && !idEl) {
              if (retry < 5) return setTimeout(() => tryBind(retry + 1), 300);
              console.warn(`⚠️ フォント切替要素が見つかりません: ${gpoName}`);
              return;
            }

            // ラジオ全部にリスナー
            radios.forEach(r => r.addEventListener('change', applyFont));
            // select 等にもリスナー
            if (idEl) idEl.addEventListener('change', applyFont);

            // 初回反映
            applyFont();
          };

          tryBind();
        });
      }



      // 🔑 テキスト位置の適用（comboKey 使用）
      if (config.designCombination && config.designCombination.keys) {
        const comboKey = config.designCombination.keys.map(id => {
          const el = document.getElementById(id);
          if (el) return el.value.trim();
          const radio = document.querySelector(`input[name="${id}"]:checked`);
          if (radio) return radio.value.trim();
          return '';
        }).join('|');

  //        console.log("🧩 comboKey:", comboKey);
  ///        console.log("🔍 designTextPositionMap キー一覧:", Object.keys(config.designTextPositionMap));

        applyTextPositionFromDesign(comboKey, config);
      } else {
        // 単独ラベル名がキーになっている場合用の fallback（旧構成用）
        console.log("ℹ️ 単独キー使用:", selectedLabel);
        applyTextPositionFromDesign(selectedLabel, config);
      }
    })
    .catch(err => {
      console.warn("❌ designInputsReady の一部が見つかりません:", err);
    });
    
  }


  
function containsJapanese(str) {
    return /[\u3000-\u303F\u3040-\u309F\u30A0-\u30FF\u4E00-\u9FFF]/.test(str);
    }

    
function setupTextSync(config) {
  const arcRefs = config._arcRefs || {}; // ← renderPreviewで作った参照

  config.textFields.forEach((t, i) => {
    const tryBind = () => {
      const input   = document.getElementById(t.inputId);
      const display = document.getElementById(`engrave-text-${i}`); // 通常はDIV、アーチはwrap DIV
      const errorId = `engrave-text-error-${i}`;
      let errorEl   = document.getElementById(errorId);

      if (!errorEl && input) {
        errorEl = document.createElement('div');
        errorEl.id = errorId;
        errorEl.style.color = "red";
        errorEl.style.fontSize = "12px";
        input.parentNode?.insertBefore(errorEl, input.nextSibling || null);
      }

      if (!(input && display)) {
        // 要素がまだ無い場合はリトライ
        if (t._retryCount == null) t._retryCount = 0;
        if (t._retryCount < 5) {
          t._retryCount++;
          setTimeout(tryBind, 300);
        } else {
          console.warn(`⏰ テキスト同期に失敗: inputId=${t.inputId}, divId=engrave-text-${i}`);
        }
        return;
      }

      // 個別フォント適用（通常テキストdivのみ）
      const fontSetting = t.forceFont || t.Font || null;
      if (!t.arc && fontSetting) {
        const styleId = `fontface-${fontSetting.name}`;
        if (!document.getElementById(styleId)) {
          const style = document.createElement('style');
          style.id = styleId;
          style.innerHTML = `
            @font-face {
              font-family: '${fontSetting.name}';
              src: url('${fontSetting.url}') format('woff2');
              font-display: swap;
            }
          `;
          document.head.appendChild(style);
        }
        display.style.fontFamily = `'${fontSetting.name}'`;
        if (fontSetting.textColor) display.style.color = fontSetting.textColor;
      }

      // 入力イベント
      input.addEventListener('input', () => {
        const value = input.value;

        // allowedChars（文字列/RegExp両対応）
        let regex = null;
        if (t.allowedChars) {
          regex = (t.allowedChars instanceof RegExp) ? t.allowedChars : new RegExp(t.allowedChars);
        } else if (config.allowedChars) {
          regex = (config.allowedChars instanceof RegExp) ? config.allowedChars : new RegExp(config.allowedChars);
        }

        if (regex && value !== "" && !regex.test(value)) {
          if (!t.arc) display.textContent = "";
          if (arcRefs[i]) arcRefs[i].textPath.textContent = "";
          errorEl && (errorEl.textContent = "⚠️ 使用できない文字が含まれています");
          return;
        }
        if (errorEl) errorEl.textContent = "";

        // 変換（筆記体）
        let displayValue = value;
        if (t.ConvertToCursiveFormat) {
          displayValue = ConvertToCursiveFormat(value);
          input.value = displayValue;
        }

        if (t.paddingLeft)  display.style.paddingLeft  = t.paddingLeft;
        if (t.paddingRight) display.style.paddingRight = t.paddingRight;



        // フォント自動切替（全体設定）—通常テキストのみ
        if (!t.arc && config.fontByContent?.use) {
          const isJP =/[\u3040-\u30FF\u4E00-\u9FFF]/.test(displayValue);
          display.style.fontFamily = isJP
            ? `'${config.fontByContent.jpFont}'`
            : `'${config.fontByContent.enFont}'`;
          display.style.letterSpacing = isJP
            ? (config.fontByContent.jpLetterSpacing || "")
            : (config.fontByContent.enLetterSpacing || "");

          // ★ transform に追記
          if (!isJP && config.fontByContent.enRotate) {
            display.style.transform =
              (display.style.transform || "") + ` rotate(${config.fontByContent.enRotate})`;
          }
        }
        
        if (t.arc && config.fontByContent?.use && config._arcRefs?.[i]) {
          const ref = config._arcRefs[i];
          const isJP = /[\u3040-\u30FF\u4E00-\u9FFF]/.test(displayValue);
          if (!isJP) {
          ensureFontFaceOnce({
            name: config.fontByContent.enFont,
            url: config.font.en?.url
          });
        } else {
          ensureFontFaceOnce({
            name: config.fontByContent.jpFont,
            url: config.font.jp?.url
          });
        }


        ref.text.style.fontFamily = isJP
          ? config.fontByContent.jpFont
          : config.fontByContent.enFont;

        const spacing = isJP
          ? (config.fontByContent.jpLetterSpacing || "")
          : (config.fontByContent.enLetterSpacing || "");
        if (spacing) {
          ref.text.setAttribute("letter-spacing", spacing);
        }

        }


        // ==== アーチ or 通常で分岐 ====
        if (t.arc && arcRefs[i]) {
          // --- アーチ文字更新 ---
          const ref = arcRefs[i];
          ref.textPath.textContent = displayValue;

          // 見た目（フォント/色）
          if (config.fontByContent?.use) {
            // 🔠 fontByContent を優先
            const isJP = /[\u3040-\u30FF\u4E00-\u9FFF]/.test(displayValue);
            ref.text.style.fontFamily = isJP
              ? config.fontByContent.jpFont
              : config.fontByContent.enFont;

            ref.text.style.letterSpacing = isJP
              ? (config.fontByContent.jpLetterSpacing || "")
              : (config.fontByContent.enLetterSpacing || "");

            // 必要なら回転などもここで
            if (!isJP && config.fontByContent.enRotate) {
              ref.text.style.transform =
                (ref.text.style.transform || "") + ` rotate(${config.fontByContent.enRotate})`;
            }

          } else {
            // 🟤 従来のフォント指定にフォールバック
            if (t.font && t.font.name) {
              ensureFontFaceOnce(t.font);
              ref.text.style.fontFamily = t.font.name;
            } else if (config.font?.name) {
              ref.text.style.fontFamily = config.font.name;
            } else if (config.font?.jp?.name || config.font?.en?.name) {
              ref.text.style.fontFamily = (config.font.jp?.name || config.font.en?.name);
            }
          }

          if (t.fontSize)      ref.text.style.fontSize      = t.fontSize;
          if (t.letterSpacing) ref.text.style.letterSpacing = t.letterSpacing;
          if (t.arc?.dy != null) ref.text.setAttribute('dy', String(t.arc.dy));
          if (t.textColor) {
            ref.text.style.fill = t.textColor;
          } else if (config.font?.textColor) {
            ref.text.style.fill = config.font.textColor;
          }





          // 必要なら自動フィット（maxWidth/Height指定時）
          // アーチ専用の自動調整（弧の長さに合わせる）
          // レイアウト確定後に長さを測ってフィット
          if (ref._rafFit) cancelAnimationFrame(ref._rafFit);
          ref._rafFit = requestAnimationFrame(() => adjustArcFontSize(ref, t));


        } else {
          // --- 通常テキスト更新 ---
          // 値反映
          display.textContent = displayValue;

          // transform組み立て
  let transform = "";
  if (t.align === "center") transform += "translateX(-50%) ";
  if (t.centerY) transform += "translateY(50%) ";
  if (!t.arc && config.fontByContent?.use) {
    const isJP = /[\u3000-\u303F\u3040-\u30FF\u4E00-\u9FFF]/.test(displayValue);
    if (!isJP && config.fontByContent.enRotate) {
      transform += `rotate(${config.fontByContent.enRotate}) `;
    }
  }
  const fitCfg = getFitToBoxConfig(t, displayValue);
  if (fitCfg) {
    display.style.fontSize = t.fontSize || "800px";
    display.style.transformOrigin = "center center";

    const scaleX = fitCfg.width / display.scrollWidth;
    const scaleY = fitCfg.height / display.scrollHeight;

    transform += `scale(${scaleX}, ${scaleY})`;
    display.style.transform = transform.trim();
  } else {
    display.style.transform = transform.trim();
    adjustFontSize(display, t);


        }

        }
      });

      // 初期表示（即時反映）
      input.dispatchEvent(new Event('input'));
    };
    tryBind();
  });
  }






  
function setupDesignChange(config) {
  // ── 複合キー（select-1 × メッセージ… など） ─────────────────────────
  if (config.designCombination) {
    const ids = config.designCombination.keys;

    const getSelectedValues = () =>
      ids.map(id => {
        const el = document.getElementById(id);
        if (el) return extractGPOValue(el.value);
        const checked = document.querySelector(`input[name="${CSS.escape(id)}"]:checked`);
        if (checked) return extractGPOValue(checked.value);
        return "";
      });

    const updateDesign = () => {
      const comboKey = getSelectedValues().join("|");
      const file = config.designCombination.images[comboKey];
      const img = document.getElementById("engrave-design");
      const fallback = `${config.designImageBaseUrl}/preview_without_design.png`;
      // ★一致しない・未選択ならフォールバック
      if (img) img.src = file ? `${config.designImageBaseUrl}/${file}` : fallback;
      };


    Promise.all([
      waitForElement("#engrave-design", 20, 200),
      ...ids.map(id => waitForElement(`#${CSS.escape(id)}, input[name="${CSS.escape(id)}"]`, 20, 200))
    ])
      .then(() => {
        updateDesign(); // 初回反映
        ids.forEach(id => {
          const el = document.getElementById(id);
          if (el) el.addEventListener("change", updateDesign);
          document
            .querySelectorAll(`input[name="${CSS.escape(id)}"]`)
            .forEach(r => r.addEventListener("change", updateDesign));
        });
      })
      .catch(e => console.warn("❌ designCombination 待機失敗:", e));

    return; // ここで終わり
  }

  // ── 単独のデザイン選択（ラジオ1組） ──────────────────────────────
  if (config.designImages && config.designImageSelectorName) {
    const selectorName = config.designImageSelectorName;
    const designMap = Object.fromEntries(
      (config.designImages || []).map(d => [d.label.trim(), `${config.designImageBaseUrl}/${d.filename}`])
    );

    const updateDesign = () => {
      const selected = document.querySelector(`input[name="${selectorName}"]:checked`);
      const img = document.getElementById("engrave-design");
      const fallback = `${config.designImageBaseUrl}/preview_without_design.png`;

      if (!img) return;

      if (!selected) {
        // ★未選択 → フォールバック
        img.src = fallback;
        return;
      }
      const labelEl = document.querySelector(`label[for="${selected.id}"]`);
      const selectedLabel = labelEl ? labelEl.textContent.trim() : "";
      const designUrl = designMap[selectedLabel];

      // ★一致しない → フォールバック
      img.src = designUrl || fallback;
      };


    waitForElement(`#engrave-design`, 20, 200)
      .then(() => waitForElement(`input[name="${selectorName}"]`, 20, 200))
      .then(() => {
        updateDesign(); // 初回反映
        document
          .querySelectorAll(`input[name="${selectorName}"]`)
          .forEach(r => r.addEventListener("change", updateDesign));
      })
      .catch(err => console.warn("❌ デザイン選択欄の取得に失敗:", err));
  }
  }

// ── 複数レイヤーの画像更新（堅牢版） ─────────────────────────────
function setupDesignComboLayersChange(config) {
  if (!config.designComboLayers) return;

  const baseUrl = config.designImageBaseUrl || '';
  const layers  = config.designComboLayers;

  const readVal = (nameOrId) => {
    const byId = document.getElementById(nameOrId);
    if (byId) return extractGPOValue(byId.value);
    const checked = document.querySelector(`input[name="${CSS.escape(nameOrId)}"]:checked`);
    return checked ? extractGPOValue(checked.value) : '';
  };

  const updateAllLayers = () => {
    layers.forEach(layer => {
      const imgEl = document.getElementById(`design-layer-${layer.id}`);
      if (!imgEl) return;

      let rel = '';

      // 1) 複合キー
      if (layer.combination && Array.isArray(layer.combination.keys)) {
        const key = layer.combination.keys.map(readVal).join('|');
        rel = (layer.combination.images && layer.combination.images[key]) || layer.fallback || '';

      // 2) 単独キー
      } else if (layer.single && layer.single.key) {
        const v = readVal(layer.single.key);
        rel = (layer.single.images && layer.single.images[v]) || layer.fallback || '';

      // 3) 旧形式サポート（layer.key / layer.images）
      } else if (layer.key && layer.images) {
        const v = readVal(layer.key);
        rel = layer.images[v] || layer.fallback || '';

      // 4) 完全固定ファイル
      } else if (layer.filename) {
        rel = layer.filename;
      }

      if (rel) {
        imgEl.src = `${baseUrl}/${rel}`;
        imgEl.style.display = '';
      } else {
        // マッチしない場合は消す（プレースホルダ不要なら空でOK）
        imgEl.removeAttribute('src');
        imgEl.style.display = 'none';
      }
    });
  };

  // 監視対象キーの重複をまとめてバインド
  const keySet = new Set();
  layers.forEach(layer => {
    (layer.combination?.keys || (layer.single?.key ? [layer.single.key] : [])).forEach(k => keySet.add(k));
  });

  const bindKey = (k) => {
    waitForElement(`#${CSS.escape(k)}, input[name="${CSS.escape(k)}"]`, 20, 200)
      .then(() => {
        const byId = document.getElementById(k);
        if (byId) byId.addEventListener('change', updateAllLayers);
        document.querySelectorAll(`input[name="${CSS.escape(k)}"]`).forEach(r => r.addEventListener('change', updateAllLayers));
        updateAllLayers(); // 初回
      })
      .catch(() => updateAllLayers()); // 要素未出現でも一度更新
  };

  keySet.forEach(bindKey);

  // 念のため初回実行
  updateAllLayers();
  }






function setupBaseImageChange(config) {
        if (!config.baseImages || !config.baseImageSelectorName) return;
      
        const inputName = config.baseImageSelectorName; // ← 商品ごとの設定から取得
      
        const updateBaseImage = () => {
          const selected = document.querySelector(`input[name="${inputName}"]:checked`);
          if (!selected) {
            console.warn("⚠️ 選択中のラジオが見つかりません");
            return;
          }
      
          const selectedValue = selected.value.trim();
          const newBaseUrl = config.baseImages[selectedValue];
          if (newBaseUrl) {
            const baseImg = document.querySelector('.engrave-preview-container .base');
            if (baseImg) {
              baseImg.src = newBaseUrl;
    //            console.log("🖼️ ベース画像を更新:", newBaseUrl);
            }
          } else {
            console.warn("⚠️ 対応するベース画像が見つかりません:", selectedValue);
          }
        };
      
        // 初期表示にも対応
        updateBaseImage();
      
        // ラジオボタンの変化を監視
        const radios = document.querySelectorAll(`input[name="${inputName}"]`);
        radios.forEach(radio => {
          radio.addEventListener('change', updateBaseImage);
        });
  }

// ✅ GPOに連動したフォント切替（従来通り）
function setupFontChange(config) {
    
    
    if (config.fontByGPO) {
      Object.entries(config.fontByGPO).forEach(([id, fontMap]) => {
        waitForElement(`#${id}, input[name="${id}"]`) 
          .then(el => {
            const applyFont = () => {
              const selected = el.value.trim();
              const font = fontMap[selected];
              if (!font) {
                console.warn(`⚠️ フォント設定なし: ${selected}`);
                return;
              }

              applyFontToPreview(font, config.textFields);
              console.log("🔠 GPO連動フォント切替:", selected, font.name);
            };

            el.addEventListener('change', applyFont);
            applyFont(); // 初回反映
          })
          .catch(err => console.warn(`⚠️ フォント切替要素が見つかりません: ${id}`));
      });
    

    }

    // ✅ デザイン選択によるフォント切替（designFontMap）
    if (config.designFontMap && config.designImages) {


    waitForElement(`input[name="${config.designImageSelectorName}"]:checked`)
      .then(() => {
        applyFontFromDesign(config);
        const radios = document.querySelectorAll(`input[name="${config.designImageSelectorName}"]`);
        radios.forEach(radio => radio.addEventListener('change', () => applyFontFromDesign(config)));
      })
      .catch(err => console.warn("⚠️ デザイン用フォント切替の要素が見つかりません:", err));
    }

    applyFontFromDesign(config);
    // ✅ designCombination のキーに連動して再実行
    if (config.designCombination && config.designCombination.keys) {
      config.designCombination.keys.forEach(id => {
        waitForElement(`#${id}, input[name="${id}"]`) 
          .then(el => {
            el.addEventListener('change', () => applyFontFromDesign(config));
          })
          .catch(err => {
            console.warn(`⚠️ designCombination の GPO項目が見つかりません: ${id}`, err);
          });
      });
    }


  }


/* ==== curved text (arc) support ======================================= */
// 円弧パス生成（中心(cx,cy), 半径r, 角度start→end）
function createArcField(i, t) {
    const wrap = document.createElement('div');
    wrap.className = 'engrave-preview-arc';
    wrap.id = `engrave-text-${i}`;
    Object.assign(wrap.style, {
      position: 'absolute',
      left: '0', top: '0',
      width: '100%',   // ★ここを 100%
      height: '100%',  // ★ここを 100%
      pointerEvents: 'none'
    });

    const svgNS = 'http://www.w3.org/2000/svg';
    const xlinkNS = 'http://www.w3.org/1999/xlink';

    const svg = document.createElementNS(svgNS, 'svg');
    svg.setAttribute('viewBox', '0 0 800 800'); // 座標系は800基準のまま
    svg.setAttribute('width',  '100%');         // ★ここを 100%
    svg.setAttribute('height', '100%');         // ★ここを 100%
    svg.setAttribute('xmlns', svgNS);
    svg.setAttribute('xmlns:xlink', xlinkNS);

    const defs = document.createElementNS(svgNS, 'defs');
    const path = document.createElementNS(svgNS, 'path');
    const pathId = `arc-path-${i}`;
    path.setAttribute('id', pathId);
    defs.appendChild(path);

    const text = document.createElementNS(svgNS, 'text');
    const textPath = document.createElementNS(svgNS, 'textPath');

    textPath.setAttribute('href', `#${pathId}`);
    textPath.setAttributeNS(xlinkNS, 'xlink:href', `#${pathId}`);
    textPath.setAttribute('startOffset', t.arc.startOffset || '50%');
    text.setAttribute('text-anchor', t.arc.textAnchor || 'middle');

    // フォント・色
    //text.style.fontFamily = (t.font?.name) ? t.font.name : (t.fontFamily || 'inherit');
    if (t.fontSize)      text.style.fontSize      = t.fontSize;
    if (t.letterSpacing) text.style.letterSpacing = t.letterSpacing;
    text.style.fill = t.textColor || '#000'; // ★色が継承されないので明示

    text.appendChild(textPath);
    svg.appendChild(defs);
    svg.appendChild(text);


    
    // 追加: dy サポート
    if (typeof t.arc.dy !== "undefined") {
      text.setAttribute("dy", t.arc.dy);
    }
    wrap.appendChild(svg);

    const d = describeArc(t.arc.cx, t.arc.cy, t.arc.r, t.arc.startDeg, t.arc.endDeg);
    path.setAttribute('d', d);

    return { wrap, svg, text, textPath, path };
  }









//拡大鏡
function setupCursorMagnifier(container) {
    // PC / ポインタが細かい環境のみ
    if (!window.matchMedia('(pointer:fine)').matches || window.matchMedia('(max-width:600px)').matches) return;

    const wrapper = document.getElementById('engraving-preview-wrapper');
    if (!wrapper || !container) return;

    // --- ルーペ要素を作成 ---
    const lens = document.createElement('div');
    lens.className = 'engrave-magnifier';

    // 中身は「800x800の原寸コンテンツ」をクローンして拡大表示に使う
    const content = container.cloneNode(true);
    content.classList.add('magnifier-content');

    // クローン側は ID を外して既存JSと干渉しないようにする
    content.querySelectorAll('[id]').forEach(n => n.removeAttribute('id'));

    // 重要：クローンはスケールされていない「原寸表示」に直す
    content.style.width = '800px';
    content.style.height = '800px';
    content.style.transform = 'translate(0,0) scale(1)';

    // 元コンテナは 800→400 表示のため transform: scale(0.5) している前提
    const getScale = (el) => {
      const tf = getComputedStyle(el).transform;
      if (!tf || tf === 'none') return 1;
      const m = tf.match(/matrix\(([^,]+),/);
      return m ? parseFloat(m[1]) : 1;
    };
    const previewScale = getScale(container); // 例: 0.5

    const MAG = 1.0; // 拡大率（お好みで 1.2〜2.0）
    const SIZE = 230; // ルーペ直径
    const R = SIZE / 2;

    lens.appendChild(content);
    wrapper.appendChild(lens);

    // --- 元と同期（テキスト/画像変更を追従） ---
    const sync = () => {
      const scrollPos = { x: content.scrollLeft, y: content.scrollTop }; // 念のため保持
      content.innerHTML = container.innerHTML;
      content.querySelectorAll('[id]').forEach(n => n.removeAttribute('id'));
      content.scrollLeft = scrollPos.x; content.scrollTop = scrollPos.y;
    };
    let raf = 0;
    const mo = new MutationObserver(() => {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(sync);
    });
    mo.observe(container, { subtree: true, childList: true, attributes: true, characterData: true });

    // --- 位置更新 ---
    const move = (e) => {
      const rect = wrapper.getBoundingClientRect();
      const x400 = e.clientX - rect.left;
      const y400 = e.clientY - rect.top;

      // 400x400表示 → 800x800座標へ変換
      const x = x400 / previewScale;
      const y = y400 / previewScale;

      // 丸枠の位置（表示座標）
      lens.style.left = (x400 - R) + 'px';
      lens.style.top  = (y400 - R) + 'px';
      lens.style.display = 'block';

      // クローン内容を、カーソル点が丸の中央に来るように移動して拡大
      //   translate の中身は「拡大後にカーソルが中央へ来るように」調整
      content.style.transform = `translate(${-x * MAG + R}px, ${-y * MAG + R}px) scale(${MAG})`;
    };

    const leave = () => { lens.style.display = 'none'; };

    // 万一、別CSSで display:none されて丸枠が出ない場合の簡易デバッグキー（Mでトグル）
    document.addEventListener('keydown', (ev) => {
      if (ev.key.toLowerCase() === 'm') {
        lens.style.display = (lens.style.display === 'none' || !lens.style.display) ? 'block' : 'none';
      }
    });

      wrapper.addEventListener('mousemove', move);
    wrapper.addEventListener('mouseenter', () => {
      lens.style.display = 'block';
      wrapper.classList.add('cursor-hidden');   // ← カーソル消す
    });
    wrapper.addEventListener('mouseleave', () => {
      lens.style.display = 'none';
      wrapper.classList.remove('cursor-hidden'); // ← 復活
    });

  }


// アーチ文字の自動縮小：弧の長さに合わせる
function adjustArcFontSize(ref, t) {
  // ref = { text, textPath, path }
  const initial = t.fontSize ? parseFloat(t.fontSize) : 28;
  const minSize = t.minFontSize ? parseFloat(t.minFontSize) : 8;
  const ratio   = (t.fitRatio != null) ? t.fitRatio : 1.0; // 0〜1（余白用）

  const pathLen = ref.path.getTotalLength();
  const fitLen  = pathLen * ratio;

  let size = initial;
  ref.text.style.fontSize = size + "px";

  // 実長は <text> から取る（<textPath> では 0 になりがち）
  const measure = () => ref.text.getComputedTextLength();

  // 縮小
  let textLen = measure();
  let guard = 120; // 無限ループ防止
  while (textLen > fitLen && size > minSize && guard--) {
    size -= 1;
    ref.text.style.fontSize = size + "px";
    textLen = measure();
  }

  // 余裕があれば初期値まで少し戻す
  while (size < initial && guard--) {
    size += 1;
    ref.text.style.fontSize = size + "px";
    textLen = measure();
    if (textLen > fitLen) {
      size -= 1;
      ref.text.style.fontSize = size + "px";
      break;
    }
  }
  }





  
});